const messages = {
  zh: {
    translations: {
      gridHotelFeedback: {
        dashboard: '仪表板',
        service_grid: '调查与满意度网格',
        service_grid_single: '调查与满意度网格',
        listed_grids: '调查与满意度网格列表如下',
        create_service_grid: '创建调查与满意度网格',
        title: '标题',
        status: '状态',
        grid_deleted: '网格已删除！',
        grid_deleted_message: '调查与满意度网格已成功删除。',
        error: '错误',
        error_delete_message: '删除调查与满意度网格时发生错误。',
        service_grid_name: '标题',
        service_grid_name_placeholder: '例如：满意度调查',
        fill_information_create: '请填写以下信息并点击创建按钮以保存更改',
        missing_fields: '必填字段',
        missing_fields_message: '“标题”字段和“项目列表”是必填项！',
        grid_created: '网格已创建',
        grid_created_message: '注册成功完成！',
        error_create_message: '创建网格时发生错误！',
        service_list: '项目列表',
        service_placeholder: '添加一个项目（例如：房间质量）',

        // CHAVES ADICIONADAS/MIGRADAS PARA A PÁGINA DE EDIÇÃO (UPDATE)
        edit_service_grid: '编辑调查与满意度网格',
        save_changes_edit: '请填写以下信息并点击保存按钮以确认更改',
        grid_updated: '网格已更改',
        grid_updated_message: '编辑成功完成！',
        error_update_message: '更改网格时发生错误！',

        general: {
          actions: '操作',
          edit: '编辑',
          delete: '删除',
          active: '启用',
          inactive: '禁用',
        },
        buttons: {
          create: '创建',
          back: '返回',
          save: '保存',
        },
      },
      // 商店语言管理页面的翻译
      translate_stores: {
        page_title: '商店语言和关系管理',
        page_subtitle: '管理系统中每个商店的翻译语言和关系。',
        page_title_relationships: '商店关系管理',
        page_subtitle_relationships: '管理系统中商店之间的关系。',
        tab_translations: '管理语言',
        tab_relations: '商店关系',
        breadcrumb: {
          dashboard: '仪表盘',
          translate_stores: '管理语言',
        },
        filters: {
          status: '状态',
          type: '类型',
          active: '活动',
          inactive: '非活动',
          both: '两者',
          all_types: '全部',
          status_placeholder: '商店状态',
          type_placeholder: '商店类型',
          filter_button: '筛选',
        },
        status_options: {
          active: '活动',
          inactive: '非活动',
          both: '两者',
          all_types: '全部',
        },
        languages: {
          portuguese: '葡萄牙语',
          spanish: '西班牙语',
          english: '英语',
          french: '法语',
          german: '德语',
          italian: '意大利语',
          japanese: '日语',
          korean: '韩语',
          chinese: '國語',
        },
        table: {
          headers: {
            type: '类型',
            id: 'ID',
            name: '名称',
            subdomain: '子域名',
            status: '状态',
            created: '创建于',
            cnpj: 'CNPJ',
            actions: '操作',
          },
          type: '类型',
          id: 'ID',
          name: '名称',
          subdomain: '子域名',
          status: {
            active: '活动',
            inactive: '非活动',
          },
          created: '创建于',
          cnpj: 'CNPJ',
          actions: '操作',
        },
        actions: {
          manage_languages: '管理语言',
          edit: '编辑',
        },
        messages: {
          success: {
            title: '成功',
            save: '语言保存成功！',
          },
          error: {
            title: '错误',
            load_data: '加载商店数据时出错！',
            save_languages: '保存语言时出错！',
          },
        },
        modal: {
          title: '管理语言',
          description: '选择此商店可用于翻译的语言：',
          alert: {
            title: '注意',
            message: '激活或停用此商店应使用的翻译语言。',
          },
          buttons: {
            cancel: '取消',
            save: '保存',
          },
        },
        relations: {
          no_relations: '未找到任何关系',
          create_title: '创建关系',
          edit_title: '编辑关系',
          parent_label: '父级商店',
          child_label: '子级商店',
          parent_missing: '请选择父级商店',
          child_missing: '请选择子级商店',
          same_store_error: '父级商店不能与子级商店相同',
          created_success: '关系创建成功',
          updated_success: '关系更新成功',
          deleted_success: '关系删除成功',
          error_create: '创建关系时出错',
          error_update: '更新关系时出错',
          error_delete: '删除关系时出错',
          store_not_found: '未找到商店',
          all_option: '所有',
          cancel: '取消',
          save: '保存',
          delete_confirm: '是，删除',
          create_button: '创建关系',
          save_changes: '保存更改',
          create_description:
            '定义哪个商店将是父级商店，哪个将是子级商店。一个父级商店可以有多个子级商店并管理其配置。',
          edit_description: '编辑所选商店之间的关系。更改将立即应用。',
          summary_title: '关系摘要：',
          tips_title: '重要提示：',
          tip_parent_multiple: '一个父级商店可以有多个子级商店',
          tip_child_single: '一个子级商店可以有多个父级',
          tip_all_available: '所有商店（活动和非活动）都可供选择',
          click_new: '点击“新建关系”开始',
          message_delete: '您确定要删除此关系吗？此操作无法撤消。',
        },
      },
      hospitality_review: {
        page_title: '酒店评价',
        page_subtitle: '管理和监控酒店客人的评价和评分。',
        breadcrumb: {
          dashboard: '仪表盘',
          hospitality: '酒店服务',
          reviews: '评价',
        },
        statistics: {
          total_reviews: '评价总数',
          average_rating: '总体平均分',
        },
        filters: {
          filter_by_type: '按类型筛选',
          filter_by_rating: '按评分筛选',
        },
        type_options: {
          all_types: '全部',
          general: '一般',
          room: '客房',
          food: '餐饮',
          service: '服务',
          cleanliness: '清洁度',
          activities: '活动',
        },
        rating_options: {
          all_ratings: '所有评分',
          five_stars: '5 星',
          four_stars: '4 星',
          three_stars: '3 星',
          two_stars: '2 星',
          one_star: '1 星',
        },
        table: {
          headers: {
            rating: '评分',
            type: '类型',
            comment: '评论',
            date: '日期',
            actions: '操作',
          },
          actions: {
            view_full_review: '查看完整评价',
          },
          status: {
            approved: '已批准',
            pending: '待定',
          },
        },
        modal: {
          review_title: '评价来自',
          fields: {
            rating: '评分',
            type: '类型',
            status: '状态',
            date: '日期',
            comment: '评论',
            email: '电子邮件',
          },
          guest_anonymous: '匿名',
        },
        messages: {
          success: {
            review_deleted: '评价已删除',
            delete_success: '删除操作成功！',
            status_updated: '状态已更新',
            approved_success: '评价批准成功！',
            suspended_success: '评价暂停成功！',
          },
          error: {
            title: '错误',
            load_reviews: '加载酒店评价时出错！',
            invalid_id: '无效的删除ID！',
            delete_error: '删除评价时出错！',
            status_error: '更改评价状态时出错！',
          },
          confirm: {
            delete_title: '确认删除',
            delete_text: '您确定要删除此评价吗？',
            delete_confirm: '是，删除',
            delete_cancel: '取消',
          },
        },
      },
      hospitality_info: {
        page_title: '酒店信息',
        page_subtitle: '管理酒店的联系方式、时间表和服务。',
        tabs: {
          contact: '联系方式',
          hours: '时间表',
          services: '服务',
        },
        contact: {
          phone_label: '电话 *',
          phone_placeholder: '(11) 99999-9999',
          whatsapp_label: 'WhatsApp',
          whatsapp_placeholder: '(11) 99999-9999',
          email_label: '电子邮件 *',
          email_placeholder: 'hotel@email.com',
        },
        hours: {
          recepcao_label: '接待处 *',
          recepcao_placeholder: '08:00 - 22:00',
          restaurante_label: '餐厅 *',
          restaurante_placeholder: '12:00 - 23:00',
          piscina_label: '游泳池 *',
          piscina_placeholder: '09:00 - 18:00',
          spa_label: '水疗',
          spa_placeholder: '10:00 - 20:00',
          academia_label: '健身房',
          academia_placeholder: '06:00 - 22:00',
        },
        services: {
          title: '酒店服务',
          add_button: '添加服务',
          remove_button: '移除',
          service_number: '服务',
          service_title_label: '服务标题',
          service_title_placeholder: '例如：客房服务',
          service_description_label: '描述',
          service_description_placeholder: '描述服务',
        },
        actions: {
          save_button: '保存',
        },
        messages: {
          error_title: '错误',
          error_text: '无法保存酒店信息。',
          success_title: '已保存！',
          success_text: '酒店信息保存成功。',
          required_phone: '电话是必填项。',
          required_email: '电子邮件是必填项。',
          required_hours: '字段 {{hour}} 是必填项。',
          required_service: '所有服务必须有标题和描述。',
        },
      },
      hospitality_schedules: {
        page_title: '酒店日程安排',
        page_subtitle: '管理酒店的活动和日程安排。',
        new_button: '新日程安排',
        edit_button: '编辑日程安排',
        delete_button: '删除日程安排',
        delete_confirm: '您确定要删除此日程安排吗？此操作无法撤消。',
        table: {
          title: '标题',
          type: '类型',
          location: '地点',
          time: '时间',
          recurrence: '重复',
          period: '期间',
          status: '状态',
          actions: '操作',
          active: '活动',
          inactive: '非活动',
          single_event: '单次活动',
          all_types: '全部',
          all_status: '所有状态',
          age_group: '年龄组',
        },
        filters: {
          type: '类型',
          type_placeholder: '选择类型',
          status: '状态',
          status_placeholder: '选择状态',
          date_init: '开始日期',
          date_init_placeholder: '开始日期',
          date_end: '结束日期',
          date_end_placeholder: '结束日期',
          search: '搜索',
          clear: '清除筛选',
        },
        messages: {
          load_error: '加载日程安排时出错！',
          delete_success: '日程安排删除成功！',
          delete_error: '删除日程安排时出错！',
        },
        age_groups: {
          all: '所有人',
          children: '兒童',
          teens: '青少年',
          adults: '成人',
          seniors: '老年人',
          family: '家庭',
        },
        types: {
          activity: '娱乐',
          food: '美食',
          event: '活动',
          tour: '游览',
        },
        singleEvent: '单次活动',
      },
      hospitality_schedule_edit: {
        page_title: '编辑日程安排',
        page_subtitle: '正在编辑: {{title}}',
        not_found: {
          title: '未找到日程安排',
          description: '您尝试编辑的日程安排未找到。',
          back_button: '返回列表',
        },
        form: {
          type_label: '类型',
          type_placeholder: '选择类型',
          type_sports: '体育',
          type_wellness: '健康',
          type_other: '其他',
          title_label: '标题',
          title_placeholder: '输入日程安排标题',
          description_label: '描述',
          description_placeholder: '描述日程安排',
          location_label: '地点',
          location_placeholder: '日程安排地点',
          time_label: '时间',
          time_placeholder: '例如: 14:00 - 16:00 或 14:00',
          time_smalltext: '格式: "HH:MM - HH:MM" 或 "HH:MM"',
          recurrence_config: '重复配置',
          single_event_radio: '单次活动 - 在特定日期发生的活动',
          recurring_event_radio: '重复活动 - 在一周中特定日期重复的活动',
          day_within_date_range_radio: '日期范围内的活动 - 在特定日期范围内发生的活动',
          days_of_week_label: '星期几',
          selected_days: '已选择: {{days}}',
          date_init_label: '开始日期',
          date_init_placeholder: '开始日期',
          date_end_label: '结束日期',
          date_end_placeholder: '结束日期 (可选)',
          status_label: '状态',
          back_button: '返回',
          save_button: '保存更改',
        },
      },
      hospitality_schedule_create: {
        page_title: '新日程安排',
        page_subtitle: '为酒店创建新日程安排',
        success: {
          title: '成功！',
          text: '日程安排创建成功！',
        },
        error: {
          title: '错误',
          text: '创建日程安排时出错！',
        },
        form: {
          title_label: '标题 *',
          title_placeholder: '输入日程安排标题',
          title_required: '标题是必填项',
          type_label: '类型 *',
          type_placeholder: '选择类型',
          type_sports: '体育',
          type_wellness: '健康',
          type_other: '其他',
          description_label: '描述 *',
          description_placeholder: '描述日程安排',
          description_required: '描述是必填项',
          location_label: '地点 *',
          location_placeholder: '日程安排地点',
          location_required: '地点是必填项',
          time_label: '时间 *',
          time_placeholder: '例如: 14:00 - 16:00 或 14:00',
          time_smalltext: '格式: "HH:MM - HH:MM" 或 "HH:MM"',
          time_required: '时间是必填项',
          recurrence_config: '重复配置',
          single_event_radio: '单次活动 - 在特定日期发生的活动',
          recurring_event_radio: '重复活动 - 在一周中特定日期重复的活动',
          day_within_date_range_radio: '日期范围内的活动 - 在特定日期范围内发生的活动',
          days_of_week_label: '星期几',
          selected_days: '已选择: {{days}}',
          date_init_label: '开始日期',
          date_init_placeholder: '开始日期',
          date_end_label: '结束日期',
          date_end_placeholder: '结束日期 (可选)',
          status_label: '状态',
          back_button: '返回',
          save_button: '保存',
        },
      },
      hospitality_banner: {
        page_title: '酒店横幅',
        page_subtitle: '管理您的酒店横幅。控制显示期限、顺序和状态。',
        breadcrumb: {
          hospitality: '酒店服务',
          publicity: '宣传',
        },
        new_button: '新宣传',
        table: {
          title: '标题',
          image: '图片',
          order: '顺序',
          period: '期间',
          created_date: '创建日期',
          status: '状态',
          actions: '操作',
        },
        actions: {
          edit: '编辑宣传',
          view: '查看详情',
          delete: '删除宣传',
        },
        modal: {
          title: '宣传 #{{id}}',
          order: '顺序',
          status: '状态',
          active: '活动',
          inactive: '非活动',
          period: '期间',
          created: '创建于',
          updated: '最近更新',
          image: '图片',
          no_image: '无图片',
        },
        delete: {
          confirm_title: '确认删除',
          confirm_text: '您确定要删除此宣传吗？',
          confirm_button: '是，删除',
          cancel_button: '取消',
          success_title: '宣传已删除',
          success_text: '删除操作成功！',
        },
        status: {
          success_title: '状态已更新',
          success_text: '宣传{{action}}成功！',
          activated: '已激活',
          deactivated: '已停用',
        },
        error: {
          title: '错误',
          load_data: '加载宣传数据时出错！',
          invalid_id: '无效的删除ID！',
          delete: '删除宣传时出错！',
          status_change: '更改宣传状态时出错！',
        },
      },
      hospitality_banner_create: {
        page_title: '创建新酒店横幅',
        page_subtitle: '填写以下信息以创建新横幅。',
        breadcrumb: {
          hospitality: '酒店服务',
          publicity: '宣传',
          create: '创建宣传',
        },
        form: {
          title_label: '横幅标题 *',
          title_placeholder: '例如: 徒步旅行...',
          order_label: '显示顺序 *',
          order_placeholder: '例如: 1, 2, 3...',
          order_smalltext: '宣传优先级顺序（数字越小越靠前）',
          status_label: '活动宣传',
          status_smalltext: '勾选以激活宣传',
          start_date_label: '开始日期 *',
          start_time_label: '开始时间 *',
          end_date_label: '结束日期 *',
          end_time_label: '结束时间 *',
          image_label: '宣传图片',
          image_select: '选择图片',
          image_formats: '接受的格式: JPG, PNG, GIF',
          image_optional: '可选 - 如果未提供，将使用默认图片',
          image_preview: '图片预览',
          image_remove: '移除图片',
        },
        preview: {
          period_title: '宣传期限：',
          start: '开始',
          end: '结束',
        },
        validation: {
          title: '验证错误',
          order_positive: '顺序必须是大于零的数字！',
          start_date_required: '开始日期是必填项！',
          end_date_required: '结束日期是必填项！',
          dates_required: '日期和时间是必填项！',
          start_before_end: '开始日期必须在结束日期之前！',
        },
        success: {
          title: '宣传已创建',
          text: '宣传创建成功！',
        },
        error: {
          title: '错误',
          text: '创建宣传时出错！',
        },
      },
      hospitality_banner_update: {
        page_title: '编辑酒店宣传',
        page_subtitle: '正在编辑宣传 #{{id}}',
        breadcrumb: {
          edit: '编辑宣传',
        },
        current_image: '当前图片',
        save_button: '保存更改',
        not_found: {
          title: '未找到宣传',
          text: '您尝试编辑的宣传未找到。',
          back_button: '返回列表',
        },
        no_changes: {
          title: '无更改',
          text: '未修改任何字段！',
        },
        success: {
          title: '宣传已更新',
          text: '宣传更新成功！',
        },
        error: {
          title: '错误',
          text: '更新宣传时出错',
          load_data: '加载宣传数据时出错！',
          update: '更新宣传时出错！',
        },
      },
      hospitality_publicity: {
        page_title: '酒店精选横幅',
        page_subtitle: '管理您的酒店精选横幅。控制显示期限、顺序和状态。',
        breadcrumb: {
          hospitality: '酒店服务',
          publicity: '宣传',
        },
        new_button: '新横幅',
        table: {
          image: '图片',
          order: '顺序',
          period: '期间',
          created_date: '创建日期',
          status: '状态',
          actions: '操作',
        },
        actions: {
          edit: '编辑宣传',
          view: '查看详情',
          delete: '删除宣传',
        },
        modal: {
          title: '宣传 #{{id}}',
          order: '顺序',
          status: '状态',
          active: '活动',
          inactive: '非活动',
          period: '期间',
          created: '创建于',
          updated: '最近更新',
          image: '图片',
          no_image: '无图片',
        },
        delete: {
          confirm_title: '确认删除',
          confirm_text: '您确定要删除此宣传吗？',
          confirm_button: '是，删除',
          cancel_button: '取消',
          success_title: '宣传已删除',
          success_text: '删除操作成功！',
        },
        status: {
          success_title: '状态已更新',
          success_text: '宣传{{action}}成功！',
          activated: '已激活',
          deactivated: '已停用',
        },
        error: {
          title: '错误',
          load_data: '加载宣传数据时出错！',
          invalid_id: '无效的删除ID！',
          delete: '删除宣传时出错！',
          status_change: '更改宣传状态时出错！',
        },
      },
      hospitality_publicity_create: {
        page_title: '创建酒店宣传',
        page_title_edit: '编辑酒店宣传',
        page_subtitle: '填写以下信息以创建新宣传。',
        breadcrumb: {
          hospitality: '酒店服务',
          publicity: '宣传',
          create: '创建宣传',
        },
        form: {
          order_label: '显示顺序 *',
          order_placeholder: '例如: 1, 2, 3...',
          order_smalltext: '宣传优先级顺序（数字越小越靠前）',
          status_label: '活动宣传',
          status_smalltext: '勾选以激活宣传',
          start_date_label: '开始日期 *',
          start_time_label: '开始时间 *',
          end_date_label: '结束日期 *',
          end_time_label: '结束时间 *',
          image_label: '宣传图片',
          image_select: '选择图片',
          image_formats: '接受的格式: JPG, PNG, GIF | 尺寸: ~200x112px | 最大大小: 2MB',
          image_optional: '可选 - 如果未提供，将使用默认图片',
          image_preview: '图片预览',
          image_remove: '移除图片',
          external_link_checkbox: '包含外部链接',
          external_link_label: '外部链接',
          external_link_placeholder: 'https://example.com',
          description_label: '横幅描述',
          description_smalltext: '* 最多 {qtd} 个字符',
          title_label: '横幅标题',
          title_placeholder: '例如：徒步旅行...',
          title_smalltext: '* 最多 {qtd} 个字符',
        },
        preview: {
          period_title: '宣传期限：',
          start: '开始',
          end: '结束',
        },
        validation: {
          title: '验证错误',
          order_positive: '顺序必须是大于零的数字！',
          start_date_required: '开始日期是必填项！',
          end_date_required: '结束日期是必填项！',
          dates_required: '日期和时间是必填项！',
          start_before_end: '开始日期必须在结束日期之前！',
          external_link_required: '选择该选项时，外部链接是必填项！',
          image_size_error: '图像大小必须最大为2MB！',
          image_dimensions_error: '图像尺寸应该大约为200x112像素！当前：{{current}}',
          image_invalid: '无效的图像文件！请选择有效的图像。',
        },
        success: {
          title: '宣传已创建',
          text: '宣传创建成功！',
        },
        error: {
          title: '错误',
          text: '创建宣传时出错！',
          update: '更新宣传时出错！',
        },
        not_found: {
          title: '未找到宣传',
          text: '您尝试编辑的宣传未找到。',
          back_button: '返回列表',
        },
        no_changes: {
          title: '无更改',
          text: '未修改任何字段！',
        },
        current_image: '当前图片',
      },
      // 添加到文件
      service_list: {
        filters: {
          categories: '类别',
          category_placeholder: '类别',
          filter_button: '筛选',
          all_categories: '全部',
        },
        table: {
          schedule: '时间表',
          extension: '分机号',
        },
        actions: {
          delete_service: '删除服务',
        },
      },
      // 添加到文件
      service_create: {
        page_title: '注册服务',
        breadcrumb: {
          services: '服务',
          create: '创建',
        },
        form: {
          classification_placeholder: '选择一个分类',
          name_label: '名称',
          name_placeholder: '服务名称',
          description_label: '描述',
          description_placeholder: '服务描述',
          schedule_label: '营业时间',
          schedule_placeholder: '例如: 24h, 08:00-18:00, 按需',
          schedule_smalltext: '最多 50 个字符',
          extension_label: '分机号',
          extension_placeholder: '例如: 1001, 2050',
          extension_smalltext: '最多 10 个字符',
          code_label: '代码',
          code_placeholder: '服务代码',
          order_label: '顺序',
          order_placeholder: '显示顺序',
          status_label: '状态',
          status_active: '活动',
          status_inactive: '非活动',
          external_link_label: '外部链接',
          external_link_placeholder: 'https://example.com',
          priority_label: '优先级',
          priority_low: '低',
          priority_normal: '正常',
          priority_high: '高',
          priority_critical: '紧急',
        },
        icons: {
          title: '图标',
          category_label: '图标类别',
          all_categories: '全部',
          selected_icon: '已选图标',
        },
        validation: {
          missing_fields_title: '缺少字段',
          missing_fields_text: '请检查您是否填写了所有必填字段：名称、分类和图标！',
        },
        success: {
          title: '服务已注册',
          text: '注册成功！',
        },
        error: {
          title: '错误',
          text: '注册服务时出错！',
          icons_load: '查找类型时出错',
        },
      }, // 添加到文件
      service_update: {
        page_title: '编辑服务',
        page_title_full: '更新服务',
        breadcrumb: {
          edit: '编辑',
        },
        error: {
          title: '错误',
          load_data: '加载服务数据时出错！',
          text: '更新服务时出错！',
        },
        success: {
          title: '服务已更新',
          text: '编辑成功！',
        },
      },
      // 添加到文件
      service_category_create: {
        validation: {
          missing_fields_title: '缺少字段',
          missing_fields_text: '请检查您是否填写了所有字段！',
        },
        success: {
          title: '分类已注册',
          text: '注册成功！',
        },
        error: {
          title: '错误',
          text: '注册分类时出错！',
          create: '注册分类时出错！',
        },
      },

      // 添加到文件
      service_category_list: {
        page_title: '内容类别',
        page_subtitle: '这里列出了内容类别及其各自的操作。',
        breadcrumb: {
          categories: '类别',
        },
        add_button: '添加',
        table: {
          name: '名称',
          status: '状态',
          actions: '操作',
        },
        actions: {
          edit_category: '编辑类别',
          delete_category: '删除类别',
        },
        delete: {
          error_title: '错误',
          error_text: '删除类别时出错！',
          success_title: '类别已删除',
          success_text: '删除操作成功！',
          confirm_title: '您确定吗？',
          confirm_text: '类别将被删除且无法恢复！',
          cancel_button: '关闭！',
          confirm_button: '删除！',
        },
      },
      service_category_update: {
        error: {
          title: '错误',
          load_data: '加载分类数据时出错！',
          text: '更新分类时出错！',
          update: '更新分类时出错！',
        },
        success: {
          title: '分类已更新',
          text: '编辑成功！',
        },
      },
      hotelRoom: {
        status: {
          available: '可用',
          reserved: '已预订',
          maintenance: '维护中',
          occupied: '已入住',
          being_cleaning: '清洁中',
        },
        type: {
          single: '单人房',
          double: '双人房',
          twin: '双床房',
          queen: '大床房',
          king: '特大床房',
          suite: '套房',
          junior_suite: '初级套房',
          master_suite: '主套房',
          presidential: '总统套房',
          family: '家庭房',
          accessible: '无障碍客房',
        },
      },
      hospitality_room_reservation: {
        create: {
          wizard_step_customer: '客户',
          wizard_step_reservation: '预订',
          wizard_step_confirmation: '确认',
          wizard_step1: '第 1 步',
          wizard_step2: '第 2 步',
          wizard_step3: '第 3 步',
          wizard_customer_title: '选择或注册客户',
          wizard_customer_search_placeholder: '按姓名、电子邮件或电话搜索...',
          wizard_customer_search_button: '搜索现有客户',
          wizard_customer_new_button: '注册新客户',
          wizard_customer_none_found: '未找到任何客户',
          wizard_customer_showing_first: '显示前 20 个结果。优化您的搜索以查找其他客户。',
          wizard_reservation_title: '预订数据',
          wizard_reservation_room_label: '客房 *',
          wizard_reservation_room_subtitle: '点击客房以选择。您可以选择多个客房。',
          wizard_reservation_room_placeholder: '选择客房',
          wizard_reservation_status_label: '预订状态',
          wizard_reservation_status_placeholder: '选择状态',
          wizard_reservation_checkin_label: '入住日期和时间 *',
          wizard_reservation_checkout_label: '退房日期和时间 *',
          wizard_reservation_password_label: '客户密码',
          wizard_reservation_password_placeholder: '输入客户密码',
          wizard_reservation_generate_password: '生成密码',
          wizard_confirmation_title: '确认预订',
          wizard_confirmation_customer_data: '客户数据',
          wizard_confirmation_reservation_data: '预订数据',
          wizard_confirmation_room: '客房',
          wizard_confirmation_capacity: '容量',
          wizard_confirmation_price: '价格',
          wizard_confirmation_checkin: '入住',
          wizard_confirmation_checkout: '退房',
          wizard_confirmation_status: '状态',
          wizard_confirmation_password: '密码',
          wizard_confirmation_address: '地址',
          wizard_confirmation_zipcode: '邮政编码',
          wizard_confirmation_gender_male: '男性',
          wizard_confirmation_gender_female: '女性',
          wizard_confirmation_gender_other: '其他',
          wizard_confirmation_gender_not_informed: '不愿透露',
          wizard_buttons_back: '返回',
          wizard_buttons_cancel: '取消',
          wizard_buttons_next: '下一步',
          wizard_buttons_create: '创建',
          wizard_page_title: '新客房预订',
          wizard_page_subtitle: '为酒店创建新预订',
          legend: {
            title: '客房状态图例',
            available: '可用',
            selected: '已选择',
            unavailable: '不可用',
            occupied: '已占用',
            reserved: '已预订',
            being_cleaning: '清洁中',
            maintenance: '维护中',
            no_info: '无信息',
          },
        },
        customer_form: {
          title: '客户数据',
          personal_info_title: '个人信息',
          cpf_label: 'CPF *',
          cpf_placeholder: '000.000.000-00',
          name_label: '全名 *',
          name_placeholder: '输入全名',
          email_label: '电子邮件 *',
          email_placeholder: '输入电子邮件',
          birthdate_label: '出生日期 *',
          gender_label: '性别',
          gender_placeholder: '选择性别',
          gender_male: '男性',
          gender_female: '女性',
          gender_other: '其他',
          contact_info_title: '联系信息',
          phone_label: '电话 *',
          phone_placeholder: '(11) 99999-9999',
          phone_type_label: '电话类型',
          phone_type_cell: '手机',
          phone_type_landline: '座机',
          whatsapp_optin: '接受在 WhatsApp 上接收消息',
          address_title: '居住地址',
          cep_label: '邮政编码 *',
          cep_placeholder: '00000-000',
          street_label: '街道 *',
          street_placeholder: '街、大道等',
          number_label: '号码 *',
          number_placeholder: '123',
          extra_label: '补充',
          extra_placeholder: '公寓、街区等',
          district_label: '社区 *',
          district_placeholder: '社区名称',
          city_label: '城市 *',
          city_placeholder: '城市名称',
          state_label: '州 *',
          state_placeholder: 'SP',
          reference_label: '参考点',
          reference_placeholder: '靠近购物中心，广场对面等',
          terms_title: '条款和条件',
          accept_terms: '我接受使用条款和条件 *',
          lgpd_consent: '我授权处理我的个人数据 (LGPD) *',
        },
        title: '客房预订',
        subtitle: '酒店预订管理',
        breadcrumb_dashboard: '仪表盘',
        breadcrumb_reservation: '预订',
        btn_new_reservation: '新预订',
        btn_confirm: '确认预订',
        btn_checkin: '办理入住',
        btn_checkout: '办理退房',
        btn_cancel: '取消预订',
        btn_no_show: '标记为未入住',
        btn_delete: '删除预订',
        btn_details: '预订详情',
        filter_status_label: '预订状态',
        filter_status_placeholder: '选择状态',
        filter_status_all: '所有状态',
        table_reservation: '预订',
        table_room: '客房',
        table_customer: '客户',
        table_checkin: '入住',
        table_checkout: '退房',
        table_status: '状态',
        table_price: '价值',
        table_actions: '操作',
        status_confirmed: '已确认',
        status_in_progress: '进行中',
        status_completed: '已完成',
        status_cancelled: '已取消',
        status_no_show: '未入住',
        status_pending: '待定',
        msg_success_delete: '删除操作成功！',
        msg_success_update: '预订状态更新成功！',
        msg_error_delete: '删除预订时出错！',
        msg_error_update: '更新预订状态时出错！',
        msg_confirm_status_change: '您要将预订状态更改为“{status}”吗？',
        msg_confirm_checkin: '您要为此次预订办理入住吗？',
        msg_confirm_checkout: '您要完成退房吗？此操作无法撤消。',
        msg_checkout_attention: '⚠️ 注意 - 请仔细阅读：',
        msg_checkout_list: ['客户已完成付款', '没有未结清的财务问题', '所有服务均已妥善结清'],
        msg_checkout_confirm_read: '我已阅读并确认所有验证均已检查',
        msg_checkout_validation: '在继续之前，您必须确认已阅读并检查所有验证。',
        msg_confirm_delete: '删除预订',
        tab_basic: '基本信息',
        tab_summary: '摘要',
        tab_activities: '活动',
        tab_tours: '游览',
        tab_experiences: '体验',
        tab_services: '服务预订',
        tab_services_list: '服务列表',
        tab_orders: '酒店订单',
        label_loading: '正在加载...',
        label_loading_orders: '正在加载订单...',
        label_order_details: '订单详情',
        label_no_data: '未找到任何订单',
        label_pending: '目前没有预订任何订单。',
        tab_title: '酒店订单',
        label_order: '订单',
        label_orders: '订单',
        label_total_spent: '总支出：{value}',
        label_total_orders: '订单总数',
        label_total_spent_label: '总支出',
        label_total_paid_label: '总支付',
        label_products: '产品',
        label_quantity: '数量',
        label_sku: 'SKU',
        label_delivery: '配送',
        label_delivery_address: '配送地址',
        label_withdraw_address: '取货地址',
        label_financial_summary: '财务摘要',
        label_products_label: '产品',
        label_delivery_fee: '配送费',
        label_discount: '折扣',
        label_total: '总计',
        label_payment_na: '付款 N/A',
        label_payment_offline: '离线支付',
        label_payment_card: '银行卡支付',
        label_payment_credit: '信用',
      },
      hospitality_room_reservation_tabs: {
        basic_info: {
          tab_title: '基本信息',
          room_details: '房间详情',
          label_customer: '客户',
          label_room: '客房',
          label_checkin: '入住',
          label_checkout: '退房',
          label_status: '状态',
          label_price: '价值',
          label_notes: '备注',
          placeholder_notes: '添加预订备注',
          status_edit_warning: '预订状态在确认或取消后无法编辑。',
          selected_room_details: '客房 {roomNumber} - {type} (容量: {capacity}) - R$ {price}',
          selected_customer_details: '客户: {name} | 电子邮件: {email} | 电话: {phone}',
          optional_checkout: '退房是可选的，可以稍后填写。',
          status_pending: '待定',
          status_confirmed: '已确认',
          status_in_progress: '进行中',
          status_completed: '已完成',
          status_cancelled: '已取消',
          summary_capacity: '容量',
          summary_people: '人',
          btn_change_password: '更改密码',
        },
        summary: {
          tab_title: '摘要',
          label_total: '总计',
          label_paid: '已支付',
          label_pending: '待定',
          label_services: '服务',
          label_products: '产品',
          label_activities: '活动',
          label_experiences: '体验',
          label_tours: '游览',
          label_room: '客房',
          label_customer: '客户',
          label_checkin: '入住',
          label_checkout: '退房',
          label_status: '状态',
          label_price: '价值',
          label_notes: '备注',
          label_capacity: '容量',
          label_people: '人',
          label_orders: '酒店订单',
          label_payment_method: '支付方式',
          label_discount: '折扣',
          label_tax: '税费',
          label_total_with_tax: '含税总计',
          label_total_with_discount: '含折扣总计',
          label_total_paid: '总支付',
          label_total_pending: '总待定',
          label_summary: '预订摘要',
          label_details: '详情',
          label_edit: '编辑',
          label_delete: '删除',
          label_confirm: '确认',
          label_cancel: '取消',
          label_no_data: '无可用数据',
          label_success: '操作成功！',
          label_error: '操作出错！',
          label_warning: '注意',
          label_info: '信息',
          label_actions: '操作',
          label_service: '服务',
          label_product: '产品',
          label_activity: '活动',
          label_experience: '体验',
          label_tour: '游览',
          label_order: '订单',
          label_date: '日期',
          label_time: '时间',
          label_type: '类型',
          label_edit_reservation: '编辑预订',
          label_delete_reservation: '删除预订',
          label_confirm_reservation: '确认预订',
          label_cancel_reservation: '取消预订',
          label_status_confirmed: '已确认',
          label_status_in_progress: '进行中',
          label_status_completed: '已完成',
          label_status_cancelled: '已取消',
          label_status_no_show: '未入住',
          label_status_pending: '待定',
        },
        activities: {
          tab_title: '活动',
          label_activity: '活动',
          label_activities: '活动',
          label_no_data: '未找到任何活动',
          label_pending: '目前没有预订任何活动。',
          label_people: '参与者',
          label_category: '类别',
          label_location: '地点',
          label_session_time: '会话时间',
          label_skill_level: '技能水平',
          label_special_requests: '特殊要求',
          label_price: '价值',
          label_date: '日期',
          label_time: '时间',
          label_status: '状态',
          label_actions: '操作',
          label_description: '描述',
          status_confirmed: '已确认',
          status_pending: '待处理',
          status_cancelled: '已取消',
          status_completed: '已完成',
          btn_add_activity: '添加活动',
        },
        experiences: {
          tab_title: '体验',
          label_experience: '体验',
          label_experiences: '体验',
          label_no_data: '未找到任何体验',
          label_pending: '目前没有预订任何体验。',
          label_people: '参与者',
          label_category: '类别',
          label_location: '地点',
          label_session_time: '会话时间',
          label_skill_level: '技能水平',
          label_special_requests: '特殊要求',
          label_price: '价值',
          label_date: '日期',
          label_time: '时间',
          label_status: '状态',
          label_actions: '操作',
          label_description: '描述',
          status_confirmed: '已确认',
          status_pending: '待处理',
          status_cancelled: '已取消',
          status_completed: '已完成',
          btn_add_experience: '添加体验',
          label_duration: '持续时间',
          label_rating: '评分',
          label_special_occasion: '特殊场合',
          label_includes: '包括',
        },
        hotel_orders: {
          tab_title: '酒店订单',
          label_order: '订单',
          label_orders: '订单',
          label_no_data: '未找到任何订单',
          label_pending: '目前没有预订任何订单。',
          label_delivery: '配送',
          label_quantity: '数量',
          label_sku: 'SKU',
          label_delivery_address: '配送地址',
          label_withdraw_address: '取货地址',
          label_financial_summary: '财务摘要',
          label_products: '产品',
          label_products_label: '产品',
          label_total_spent: '总支出：{value}',
          label_total_orders: '订单总数',
          label_total_spent_label: '总支出',
          label_total_paid_label: '总支付',
          label_discount: '折扣',
          label_total: '总计',
          label_payment_na: '付款 N/A',
          label_payment_offline: '离线支付',
          label_payment_card: '银行卡支付',
          label_payment_credit: '信用',
          label_delivery_fee: '配送费',
          no_order_title: '未找到任何订单',
        },
        tours: {
          tab_title: '游览',
          label_tour: '游览',
          label_tours: '游览',
          label_no_data: '未找到任何游览',
          label_pending: '目前没有预订任何游览。',
          label_people: '参与者',
          label_duration: '持续时间',
          label_difficulty: '难度',
          label_rating: '评分',
          label_transfer_included: '包含接送',
          label_transfer_yes: '包含接送',
          label_transfer_no: '不含接送',
          label_schedule: '时间表',
          label_weather_concerns: '天气顾虑',
          label_physical_requirements: '体能要求',
          label_special_requests: '特殊要求',
          label_price: '价值',
          label_date: '日期',
          label_time: '时间',
          label_status: '状态',
          label_actions: '操作',
          label_description: '描述',
          status_confirmed: '已确认',
          status_pending: '待处理',
          status_cancelled: '已取消',
          status_completed: '已完成',
          btn_add_tour: '添加游览',
        },
        services: {
          title: '服务预订',
          subtitle: '已预订服务的详细信息',
          no_services: '没有预订的服务',
          service_info: '服务信息',
          service_name: '服务名称',
          service_type: '服务类型',
          description: '描述',
          room_info: '房间信息',
          room_number: '房间',
          booking_details: '预订详情',
          status: '状态',
          check_in: '入住',
          check_out: '退房',
          guest_name: '客人姓名',
          reservation_name: '预订名称',
          number_of_rooms: '房间数',
          number_of_guests: '客人数',
          adults: '成人',
          children: '儿童',
          total_price: '总价',
          price_per_night: '每晚价格',
          nights: '晚',
          additional_info: '附加信息',
          booking_date: '预订日期',
          reservation_code: '预订代码',
          payment_status: '支付状态',
          special_requests: '特殊要求',
          service_details: '服务详情',
          view_details: '查看详情',
          total_services: '总服务数',
          active_services: '活跃服务',
          pending_services: '待处理服务',
          completed_services: '已完成服务',
          service_image: '服务图片',
          no_image: '无图片可用',
        },
        services_list: {
          title: '服务列表',
          subtitle: '所有已预订的服务',
          search_placeholder: '按名称、房间或客人搜索...',
          filter_all: '全部',
          filter_active: '活跃',
          filter_pending: '待处理',
          filter_completed: '已完成',
          table_service_name: '服务',
          table_service_type: '类型',
          table_room: '房间',
          table_guest: '客人',
          table_checkin: '入住',
          table_checkout: '退房',
          table_status: '状态',
          table_price: '价格',
          table_actions: '操作',
          status_active: '活跃',
          status_pending: '待处理',
          status_completed: '已完成',
          status_cancelled: '已取消',
          no_services: '未找到服务',
          no_services_desc: '没有符合您标准的服务',
          showing: '显示',
          of: '/',
          services: '服务',
          items_per_page: '每页项目数',
          page: '页',
          previous: '上一页',
          next: '下一页',
          view_details: '查看详情',
          total_found: '总共找到',
          active_filters: '活跃筛选器',
          clear_filters: '清除筛选器',
          filter_by_status: '按状态筛选',
          search_active: '搜索活跃',
          rooms: '房间',
          guests: '客人',
          nights: '晚',
          loading: '正在加载服务...',
          error: '加载服务时出错',
          retry: '重试',
          export: '导出',
          refresh: '刷新',
        },
      },
      hospitality_hotel_room: {
        label_room_number: '客房号码 *',
        image: '客房图片',
        placeholder_room_number: '例如: 101, A201, 总统套房',
        max_20_chars: '最多 20 个字符',
        label_status: '状态',
        label_capacity: '容量 (人数)',
        placeholder_capacity: '例如: 2',
        label_price: '价格 (R$)',
        placeholder_price: '例如: 150.00',
        label_type: '客房类型',
        title: '酒店客房',
        subtitle: '酒店客房管理',
        create_multiples: '创建多个客房',
        add_room: '添加客房',
        header_number: '号码',
        header_status: '状态',
        header_type: '类型',
        header_capacity: '容量',
        header_price: '价格',
        header_actions: '操作',
        action_edit: '编辑客房',
        action_delete: '删除客房',
        modal_bulk_title: '创建多个客房',
        modal_bulk_prefix: '前缀 (可选)',
        modal_bulk_prefix_placeholder: '例如: A, B, 1st',
        modal_bulk_start: '起始号码 *',
        modal_bulk_start_placeholder: '101',
        modal_bulk_end: '结束号码 *',
        modal_bulk_end_placeholder: '110',
        modal_bulk_capacity: '容量',
        modal_bulk_capacity_placeholder: '2',
        modal_bulk_price: '价格',
        modal_bulk_price_placeholder: '150.00',
        modal_bulk_type: '类型',
        type_single: '单人房',
        type_double: '双人房',
        type_twin: '双床房',
        type_queen: '大床房',
        type_king: '特大床房',
        type_suite: '套房',
        type_junior_suite: '初级套房',
        type_master_suite: '主人套房',
        type_presidential: '总统套房',
        type_family: '家庭房',
        type_accessible: '无障碍房',
        modal_bulk_cancel: '取消',
        modal_bulk_create: '创建客房',
        breadcrumb_dashboard: '仪表盘',
        breadcrumb_hotel_room: '酒店客房',
        create_title: '创建酒店客房',
        create_subtitle: '为酒店添加新客房',
        edit_title: '编辑酒店客房',
        edit_subtitle: '编辑客房 #{room} 信息',
        breadcrumb_create: '创建客房',
        breadcrumb_edit: '编辑客房',
      },
      hospitality_experiences: {
        tab_basic: '基本信息',
        edit: '编辑体验',
        edit_subtitle: '更新体验信息',
        create: '创建体验',
        create_subtitle: '填写详细信息以创建新体验',
        tab_details: '详细项目',
        tab_image: '图片',
        tab_schedules: '时间表',
        list_title: '酒店体验',
        list_subtitle: '管理所有酒店体验',
        field_title: '标题',
        field_title_placeholder: '例如: 专属浪漫晚餐',
        field_description: '描述',
        field_description_placeholder: '详细描述提供的体验...',
        field_image: '新图片',
        field_price: '价格 (R$)',
        field_price_placeholder: '0.00',
        field_duration: '持续时间',
        field_duration_placeholder: '例如: 2 小时',
        field_type: '体验类型',
        field_rating: '评分 (0-5)',
        field_rating_placeholder: '0',
        field_status: '活动状态',
        field_includes: '包含项目',
        field_includes_placeholder: '例如: 香槟, 特殊装饰...',
        field_show_additional_services: '显示预定义服务选项',
        field_actions: '操作',
        status_active: '活动',
        status_inactive: '非活动',
        no_rating: '无评分',
        no_includes: '未包含任何项目',
        currency: 'R$',
        btn_add: '添加体验',
        btn_edit: '编辑',
        btn_delete: '移除',
        btn_update: '更新体验',
        btn_create: '创建体验',
        btn_remove: '移除',
        btn_add_item: '添加项目',
        edit_title: '编辑体验',
        create_title: '创建体验',
        msg_success_create: '体验创建成功！',
        msg_success_update: '体验更新成功！',
        msg_success_delete: '体验已移除',
        msg_success_delete_text: '体验移除成功！',
        msg_error_create: '创建体验时出错',
        msg_error_update: '更新体验时出错',
        msg_error_delete: '移除体验时出错',
        msg_error_delete_text: '无法移除体验！',
        msg_error_load: '加载体验时出错',
        msg_error_load_text: '无法加载体验数据！',
        msg_error_required_title: '标题是必填项！',
        msg_error_title_length: '标题最多 255 个字符！',
        msg_error_required_description: '描述是必填项！',
        msg_error_required_price: '价格是必填项！',
        msg_error_price_negative: '价格必须大于或等于零！',
        msg_error_required_duration: '持续时间是必填项！',
        msg_error_duration_length: '持续时间最多 100 个字符！',
        msg_error_required_includes: '必须包含至少一个项目！',
        msg_error_rating_range: '评分必须在 0 到 5 之间！',
        field_order: '顺序',
        field_order_placeholder: '例如: 1, 2, 3...',
        header_order: '顺序',
        msg_error_order_negative: '顺序必须大于或等于零！',
      },
      entertainment_services: {
        list_title: '娱乐服务',
        list_subtitle: '管理可用的娱乐服务',
        create: '创建娱乐服务',
        create_subtitle: '填写详细信息以创建新服务',
        create_title: '创建娱乐服务',
        edit: '编辑娱乐服务',
        edit_subtitle: '更新服务信息',
        edit_title: '编辑娱乐服务',
        field_title: '标题',
        field_title_placeholder: '例如：水疗和按摩',
        field_type: '服务类型',
        field_status: '活动状态',
        field_actions: '操作',
        type_experience: '娱乐体验',
        type_activity: '娱乐活动',
        type_tour: '娱乐旅游',
        status_active: '活跃',
        status_inactive: '不活跃',
        btn_add: '添加服务',
        btn_edit: '编辑',
        btn_delete: '删除',
        btn_update: '更新服务',
        btn_create: '创建服务',
        btn_search: '搜索',
        btn_clear: '清除',
        search_placeholder: '按标题搜索...',
        msg_success_create: '服务创建成功！',
        msg_success_update: '服务更新成功！',
        msg_success_delete: '服务已删除',
        msg_success_delete_text: '服务删除成功！',
        msg_error_create: '创建服务时出错',
        msg_error_update: '更新服务时出错',
        msg_error_delete: '删除服务时出错',
        msg_error_delete_text: '无法删除服务！',
        msg_error_load: '加载服务时出错',
        msg_error_load_text: '无法加载服务数据！',
        msg_error_required_title: '标题是必填项！',
        msg_error_title_length: '标题最多为255个字符！',
      },
      hospitality_activities: {
        hotel_reservation: {
          page_title: '服务预订',
          details_title: '预订详情',
          cancel_title: '取消预订',
          cancel_reason_label: '取消原因 *',
          cancel_reason_placeholder: '选择取消原因',
          cancel_reason_select: '选择原因',
          type_tour: '游览',
          type_experience: '体验',
          type_activity: '活动',
          type_room_service: '客房服务',
          status_pending: '待定',
          status_confirmed: '已确认',
          status_cancelled: '已取消',
          status_completed: '已完成',
          error_title: '错误',
          error_load: '加载预订时出错！',
          error_details: '加载预订详情时出错！',
          error_cancel: '取消预订时出错！',
          success_title: '成功',
          success_cancel: '预订取消成功！',
          warning_title: '注意',
          warning_cancel_reason: '请选择一个取消原因。',
          no_details: '此预订类型没有特定的详细信息。',
          reasons_tour: ['计划变更', '天气问题', '时间冲突', '健康原因', '酒店取消'],
          reasons_experience: [
            '入住日期变更',
            '特殊场合取消',
            '日程冲突',
            '个人原因',
            '偏好其他服务',
          ],
          reasons_activity: ['感觉不适', '时间冲突', '健康问题', '计划变更', '活动不符合预期'],
          reasons_room_service: ['计划变更', '服务不必要', '时间冲突', '个人原因', '偏好其他服务'],
        },
        create_title: '创建酒店活动',
        create_subtitle: '为酒店添加新活动',
        edit_title: '编辑酒店活动',
        edit_subtitle: '更新活动信息',
        list_title: '酒店活动',
        list_subtitle: '活动和娱乐管理',
        field_title: '活动标题 *',
        field_title_placeholder: '例如: 瑜伽课、音乐表演、儿童娱乐',
        field_title_hint: '最多 255 个字符',
        field_time: '时间 *',
        field_time_placeholder: '例如: 08:00 - 09:00, 每天下午 3 点',
        field_time_hint: '最多 100 个字符',
        field_description: '描述 *',
        field_description_placeholder: '详细描述活动、其好处以及客人可以期待的内容...',
        field_image: '活动图片',
        field_location: '地点 *',
        field_location_placeholder: '例如: 主游泳池、活动大厅、海滩',
        field_location_hint: '最多 255 个字符',
        field_capacity: '容量 *',
        field_capacity_placeholder: '例如: 20, 如果为 0 则为无限',
        field_capacity_hint: '最多 50 个字符',
        field_period: '時段 *',
        field_period_placeholder: '例如：00:15 或 01:00 或 00:30',
        field_category: '类别 *',
        field_age_group: '年龄组',
        field_price: '价格 (R$)',
        field_price_placeholder: '0.00 (免费留空)',
        field_price_hint: '免费活动留空',
        field_requires_reservation: '需要预订',
        field_requires_reservation_hint: '如果活动需要提前预订，请勾选',
        field_is_active: '活动进行中',
        field_is_active_hint: '取消勾选以暂时停用活动',
        btn_edit: '编辑活动',
        btn_delete: '删除活动',
        btn_create: '创建活动',
        btn_cancel: '取消',
        msg_success_create: '活动创建成功！',
        msg_success_update: '活动更新成功！',
        msg_success_delete: '活动删除成功！',
        msg_error_create: '创建活动时出错！',
        msg_error_update: '更新活动时出错！',
        msg_error_delete: '删除活动时出错！',
        msg_error_load: '加载活动时出错！',
        msg_error_required_title: '标题是必填项！',
        msg_error_title_length: '标题最多 255 个字符！',
        msg_error_required_description: '描述是必填项！',
        msg_error_required_time: '时间是必填项！',
        msg_error_time_length: '时间最多 100 个字符！',
        msg_error_required_location: '地点是必填项！',
        msg_error_location_length: '地点最多 255 个字符！',
        msg_error_required_capacity: '容量是必填项！',
        msg_error_capacity_length: '容量最多 50 个字符！',
        msg_error_price_negative: '价格必须大于或等于零！',
        remove_schedule: '删除时间表',
        confirm_remove_schedule: '您确定要删除此时间表吗？',
        schedule_seasonal_start: '季节开始',
        schedule_seasonal_end: '季节结束',
        schedule_start_time: '开始时间',
        schedule_end_time: '结束时间',
        add_schedule: '添加时间表',
        schedule_time: '时间 *',
        schedule_time_placeholder: '例如: 08:00 - 09:00, 每天下午 3 点',
        schedule_description: '描述 *',
        schedule_days_of_week: '星期几',
        schedule_status: '时间表活动',
        schedule_seasonal_hint: '如果适用，定义一个季节性期限',
        field_duration_hint: '持续时间，以小时和分钟计 (例如: 2h30min)',
        field_duration_placeholder: '持续时间，以小时和分钟计 (例如: 2h30min)',
        field_order: '顺序',
        field_order_placeholder: '例如: 1, 2, 3...',
        msg_error_order_negative: '顺序必须大于或等于零！',
      },
      hotel_tour: {
        create_title: '创建酒店游览',
        create_subtitle: '为酒店添加新游览',
        edit_title: '编辑酒店游览',
        edit_subtitle: '更新游览信息',
        list_title: '酒店游览',
        list_subtitle: '管理游览和短途旅行',
        field_title: '游览标题 *',
        field_difficulty: '难度',
        field_duration: '持续时间',
        field_rating: '评分',
        field_participants: '参与者',
        field_schedules: '时间表',
        field_includes: '包含',
        field_transfer: '接送',
        field_currency: '货币',
        field_currency_hint: '货币代码 (例如: BRL, USD)',
        currency_brl: '雷亚尔 (BRL)',
        currency_usd: '美元 (USD)',
        currency_eur: '欧元 (EUR)',
        field_rating_placeholder: '0.0',
        field_rating_hint: '0 到 5 星评分',
        field_participants_min: '最少参与者 *',
        field_participants_min_hint: '最少参与者人数',
        field_participants_max: '最多参与者',
        field_participants_max_placeholder: '无限留空',
        field_participants_max_hint: '最多参与者人数 (可选)',
        field_age_restriction: '年龄限制',
        field_age_restriction_placeholder: '例如: 12 岁以上, 不建议 18 岁以下',
        field_age_restriction_hint: '年龄限制 (可选)',
        field_physical_requirements: '体能要求',
        field_physical_requirements_placeholder: '例如: 良好的体能、能够长距离步行',
        field_physical_requirements_hint: '所需的体能要求 (可选)',
        field_cancellation_hours: '取消 (小时) *',
        field_cancellation_hours_hint: '提前多少小时取消',
        field_discount_children: '儿童折扣 (%)',
        field_discount_children_hint: '百分比折扣',
        field_weather_dependent: '依赖天气',
        field_weather_dependent_hint: '如果依赖天气条件，请勾选',
        field_is_active: '游览进行中',
        field_is_active_hint: '取消勾选以暂时停用',
        tab_basic: '基本信息',
        tab_details: '详细信息和配置',
        tab_schedules: '时间表',
        tab_includes: '包含项目',
        tab_image: '图片',
        no_schedule_added: '未添加任何时间表',
        click_add_schedule: '点击“添加时间表”开始。',
        includes_title: '游览包含项目',
        selected: '已选择',
        field_image_hint: '选择游览的代表性图片',
        update_info: '更新游览信息',
        field_title_placeholder: '例如: 城市观光、海滩短途旅行、历史徒步',
        field_title_hint: '最多 255 个字符',
        field_time: '时间 *',
        field_time_placeholder: '例如: 08:00 - 09:00, 每天下午 3 点',
        field_time_hint: '最多 100 个字符',
        field_description: '描述 *',
        field_description_placeholder: '描述游览、亮点以及客人可以期待的内容...',
        field_image: '游览图片',
        field_location: '地点 *',
        field_location_placeholder: '例如: 市中心、海滩、博物馆',
        field_location_hint: '最多 255 个字符',
        field_capacity: '容量 *',
        field_capacity_placeholder: '例如: 20, 如果为 0 则为无限',
        field_capacity_hint: '最多 50 个字符',
        field_category: '类别 *',
        field_price: '价格 (R$)',
        field_price_placeholder: '0.00 (免费留空)',
        field_price_hint: '免费游览留空',
        field_requires_reservation: '需要预订',
        field_requires_reservation_hint: '如果游览需要提前预订，请勾选',
        btn_edit: '编辑游览',
        btn_delete: '删除游览',
        btn_create: '创建游览',
        btn_cancel: '取消',
        table_title: '标题',
        table_time: '时间',
        table_location: '地点',
        table_category: '类别',
        table_price: '价格',
        table_capacity: '容量',
        table_actions: '操作',
        msg_success_create: '游览创建成功！',
        msg_success_update: '游览更新成功！',
        msg_success_delete: '游览删除成功！',
        msg_error_create: '创建游览时出错！',
        msg_error_update: '更新游览时出错！',
        msg_error_delete: '删除游览时出错！',
        msg_error_load: '加载游览时出错！',
        msg_error_required_title: '标题是必填项！',
        msg_error_title_length: '标题最多 255 个字符！',
        msg_error_required_description: '描述是必填项！',
        msg_error_required_time: '时间是必填项！',
        msg_error_time_length: '时间最多 100 个字符！',
        msg_error_required_location: '地点是必填项！',
        msg_error_location_length: '地点最多 255 个字符！',
        msg_error_required_capacity: '容量是必填项！',
        msg_error_capacity_length: '容量最多 50 个字符！',
        msg_error_price_negative: '价格必须大于或等于零！',
        schedule_start_time: '开始时间',
        schedule_end_time: '结束时间',
        add_schedule: '添加时间表',
        schedule_time: '时间 *',
        schedule_time_placeholder: '例如: 08:00 - 09:00, 每天下午 3 点',
        schedule_description: '描述 *',
        schedule_days_of_week: '星期几',
        schedule_status: '时间表活动',
        schedule_seasonal_hint: '如果适用，定义一个季节性期限',
        field_duration_hint: '持续时间，以小时和分钟计 (例如: 2h30min)',
        field_duration_placeholder: '持续时间，以小时和分钟计 (例如: 2h30min)',
        schedule_seasonal_start: '季节开始',
        schedule_seasonal_end: '季节结束',
        difficult: {
          easy: '简单',
          medium: '中等',
          hard: '困难',
          extreme: '极端',
        },
        field_order: '顺序',
        field_order_placeholder: '例如: 1, 2, 3...',
        header_order: '顺序',
        msg_error_order_negative: '顺序必须大于或等于零！',
      },
      months: {
        jan: '一月',
        feb: '二月',
        mar: '三月',
        apr: '四月',
        may: '五月',
        jun: '六月',
        jul: '七月',
        aug: '八月',
        sep: '九月',
        oct: '十月',
        nov: '十一月',
        dec: '十二月',
      },
      permissions: {
        food: '智能点餐',
        smartorder: '产品管理',
        category: '类别',
        subcategory: '子类别',
        product: '产品',
        mark: '品牌',
        grid: '网格',
        variation: '变体',
        catalog: '目录',
        integration: '集成',
        int_pos: 'POS',
        int_gateway: '支付方式',
        messaging: '消息',
        sms: '状态和短信',
        multichannel: '多渠道',
        report: '报告',
        saleorder: '订单',
        indicators: '指标',
        orderReport: '订单',
        imports: '图片导入',
        importProductImage: '产品',
        importProductImageSKU: '变体',
        importCategoryImage: '类别',
        customers: '客户',
        customer_report: '客户列表',
        measurement_unit: '计量单位',
        logs: '日志',
        settings: '设置',
        charge_integration: '负荷',
        summaryAccess: '访问',
        sellerAccess: '销售仪表盘',
        managerAccess: '经理仪表盘',
        managerGroupAccess: '群组经理仪表盘',
        orders: '订单',
        support: '支持',
        translate: '语言和关系',
        application: 'Webapp',
        messenger: '消息',
        others: '其他',
        settings_store: '商店设置',
        settings_hotel: '设置',
        modalities: '方式',
        delivery_tax: '配送费',
        shifts: '班次',
        whatsappweb: 'WhatsApp 网页版',
        filemanager: '文件管理器',
        payment_plans: '支付计划',
        settings_account: '账户设置',
        account: '账户',
        groups: '群组',
        users: '用户',
        terms: '条款',
        highlights: '亮点',
        menu: '菜单',
        productReport: '产品',
        optional: '附加项目列表',
        locations: '部门',
        stores_location: '场所',
        service: '服务',
        service_items: '服务',
        service_category: '类别',
        feed: '动态',
        content: '网页应用界面',
        buttons: '按钮',
        sessions: '会话',
        structured_content: '基本服务',
        orders_room_service: '客房订单',
        orders_activities: '活动订单',
        queue: '等候队列',
        queue_config: '配置',
        queue_manager: '管理',
        checkout: '客户数据',
        booking: '预订',
        booking_management: '管理',
        booking_config: '配置',
        booking_environment: '环境',
        booking_day: '当日预订',
        booking_report: '报告',
        booking_managerday: '每日管理',
        booking_management_dashboard: '预订管理仪表盘',
        table_management: '桌子管理',
        table_allocation_report: '桌子分配报告',
        table_management_dashboard: '桌子管理仪表盘',
        liveShop: '实时商务',
        icon_library: '图标库',
        stores: '商店/客户',
        segments: '细分',
        payment: '付款',
        serviceCategory: '服务类别',
        SDS: 'KDS',
        sds_manage: '我的 KDS',
        sds_layout: '个性化',
        sds_link: '配置',
        sds_display: '显示器',
        /* 聚合器 */
        config: '配置',
        config_account: '账户数据',
        config_sector: '运营部门',
        config_user: '用户',
        config_term: '条款',
        subCategory: '子类别',
        footer: '页脚资源',
        footerFeature: '启用资源',
        footerContent: '资源动态',
        footerContentAddEdit: '资源',
        webapp: '个性化',
        webapp_qrcode: '生成二维码',
        ia_menu: '人工智能',
        ia_config: '配置',
        ia_fit: '训练',
        ia_file_manager: '文件管理器',
        ia_folders: '文件夹',
        ia_files: '文件',
        ia_settings: '设置',
        ia_folders_blank: '未找到任何文件夹',
        ia_filter: '筛选',
        ia_recharge: '充值',
        ia_final_date: '结束日期',
        ia_initial_date: '开始日期',
        summarize: '仪表盘',
        consumption: '人工智能消耗',
        ct_account: '消耗和价值',
        ct_s3_account: 'S3 账户',
        ct_data_cost_account: '数据和成本',
        publication_highlight_banner: '精选横幅',
        publication: '宣传',
        cost: '成本',
        security_settings: '安全设置',
        coupon: '优惠券',
        clean_safe: '清洁与安全',
        service_requests: '服务表格',
        grid_hotel: '服务网格',
        /*酒店服务 */
        hotel_maintenance: '维护',
        hotel_room: '客房',
        hotel_reservation: '客房预订',
        hotel_activities_experiences: '活动与体验',
        hotel_activities: '活动',
        hotel_tour: '酒店游览',
        hotel_tour_schedules: '酒店游览时间表',
        hotel_tour_reservation: '一般预订',
        hotel_experiences: '体验',
        hotel_info: '信息',
        hotel_reservations: '预订',
        hotel_schedules: '酒店日程安排',
        publication_banner: '横幅',
        feed_back: '反馈',
        feedback_satisfaction: '反馈与满意度',
        grid_hotel_feedback: '评分',
        feedback_list: '表格',
        feedback: '反馈',
        post: '帖子',
        post_category: '帖子类别',
        post_content: '帖子内容',
        booking_hotel: '预订管理',
        grid_hotel_booking: '服务网格',
        booking_config_hotel: '服务预订',
        page_publications: '页面的发布',
        communication: '通信',
        communicationCenter: '通信中心',
        hotel_management: '酒店管理',
        hotel_management_entertainment: '娱乐',
      },
      customer: {
        select_group: '选择群组',
        select: '选择',
        create: '创建客户',
        create_group: '创建群组',
        edit: '查看客户',
        search_custom: '搜索...',
        customer: '客户',
      },

      buttons: {
        create: '创建',
        back: '返回',
        previous: '上一步',
        register_pluginspace: '注册 Pluginspace',
        access: '访问',
        add_modality: '添加方式',
        add_km: '添加公里',
        zip_code_list: '邮政编码列表',
        add_zip_code: '添加邮政编码',
        area: '运费区域',
        list_of_negative_renge_zip_code: '负邮政编码列表',
        add_negative_zip_code: '添加负邮政编码',
        add_user: '添加用户',
        generate_password: '生成密码',
        generate_sku: '生成 SKU',
        add_group: '添加群组',
        save: '保存',
        add_term: '添加条款',
        add_integration: '添加集成',
        filter: '筛选',
        search: '搜索',
        register_product: '注册产品',
        choose_files: '选择文件',
        add_categories: '添加类别',
        add_subcategories: '添加子类别',
        add_brand: '添加品牌',
        close: '关闭',
        add_grade: '添加网格',
        add: '添加',
        add_variation: '添加变体',
        confirm_grades: '确认网格',
        add_catalog: '添加目录',
        generete_qr_code: '生成二维码',
        personalize: '个性化',
        settings: '设置',
        add_interval: '添加间隔',
        add_gateway: '添加网关',
        overview: '概述',
        view: '查看',
        load_csv: '加载文件',
        download_csv: '下载标准 XLSX',
        att_page: '刷新页面',
        export: '导出',
        add_service: '注册服务',
        add_environment: '添加环境',
        generate_ia: '提议',
        clear_table_card: '清空桌子或订单',
        propose_image: '提议图片',
        cancel: '取消',
        next: '下一步',
      },

      global: {
        success: '成功',
        error: '错误',
        warning: '注意',
        active: '活动',
        inactive: '非活动',
      },

      modals: {
        warning_confirm: '您确定吗？',
        warning_save: '保存',
        warning_close: '关闭',
        text_close: '关闭',
      },

      general: {
        delete_item: '您要删除此项目吗？',
        delete_product_observation: '此产品的变体也将被删除，您确定要继续吗？',
        delete_classification_observation:
          '删除此类别后，所有相关产品将移至“一般”类别，您确定要继续吗？',
        delete: '删除',
        edit: '编辑',
        duplicate: '复制',
        attention: '注意',
        actions: '操作',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          '此处列出了项目及其各自的操作',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          '填写以下信息并点击“创建”按钮保存更改',
        save_changes_edit: '填写以下信息并点击“保存”按钮确认更改',
        save_changes_duplicate: '验证或更改以下信息并点击“保存”按钮确认更改',
        active: '活动',
        inactive: '非活动',
        showing: '显示',
        of: '的',
        to: '到',
        records: '记录',
        today: '今天',
        copy: '复制',
        linkS3: '链接',
        linkedS3: '已链接',
        downloadS3: '下载',
        downloadedS3: '下载已启动',
        copied: '已复制',
        copy_link: '复制销售链接',
        test: '测试',
        success: '成功',
        error: '错误',
        paymentFree: '免费',
      },

      pluginspaces: {
        hospitality: '酒店',
        food: '餐饮',
        healthcare: '医疗保健',
        varejo: '零售',
        fashion: '时尚',
      },

      dashboard: {
        totals_by_products: '按产品总计',
        totals_by_category: '按类别总计',
        last_orders: '最新订单',
        products: '产品',
        quantity: '数量',
        total: '总计',
        category: '类别',
        welcome: '欢迎使用 Ninegrid',
        describe_dashboard:
          '您可以在此找到所有工具，以简单高效地管理您的商店。探索侧边菜单以浏览我们的功能。祝您工作顺利！',
      },

      modalities: {
        modalities: '方式',
        modalitie: '方式',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          '此处列出了方式及其各自的操作',
        delivery: '配送',
        withdraw: '取货',
        active: '活动',
        inactive: '非活动',
        name: '名称',
        code: '代码',
        actions: '操作',
        search: '搜索',
        type: '类型',
        sector_name: '部门名称',
        table: '餐桌',
        room: '客房',
        counter: '柜台',
        internal: '内部配送',
        synkar: 'Synkar',
      },

      delivery_fee: {
        delivery_fee: '配送费',
        create_delivery_fee: '创建配送费',
        edit_delivery_fee: '编辑配送费',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          '填写以下信息并点击“创建”按钮保存更改',
        save_changes_edit: '填写以下信息并点击“保存”按钮确认更改',
        km_min: '最小公里数',
        km_max: '最大公里数',
        value: '价值',
        actions: '操作',
        patterns: '导入模式',
        import_file: '要导入文件，文件的第一个单元格必须遵循以下模式之一：',
        import_delivery: '按范围导入：kmmin, kmmax, Value',
        import_cep: '按邮政编码导入：cep_start, cep_end, value',
        import_cep_negative: '按负邮政编码导入：cep_start, cep_end',
        model: '模式',
        continue_import: '您的所有记录将被替换，您确定要继续吗？',
        cep_delivery: '配送邮政编码',
        cep_info: '此处列出了配送邮政编码及其各自的操作。',
        cep_start: '邮政编码开始',
        cep_end: '邮政编码结束',
        create_cep: '创建配送邮政编码',
        edit_cep: '编辑配送邮政编码',
        cep_delivery_negative: '负配送邮政编码',
        cep_info_negative: '此处列出了负配送邮政编码及其各自的操作。',
        create_cep_negative: '创建负邮政编码',
        edit_cep_negative: '编辑负邮政编码',
        delete_cep_negative: '删除负邮政编码',
      },

      user: {
        user: '用户',
        here_are_listed_the_users_along_with_their_respective_actions:
          '此处列出了用户及其各自的操作',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          '填写以下信息并点击“创建”按钮保存更改',
        save_changes_edit: '填写以下信息并点击“保存”按钮确认更改',
        picture: '照片',
        name: '名称',
        type: '类型',
        registration: '注册',
        create_user: '创建用户',
        edit_user: '编辑用户',
        profile_picture: '个人资料图片',
        password: '密码',
        generate_pass: '生成密码',
        access_level: '访问群组',
        select_a_access_level: '选择访问群组',
        select_type: '选择类型',
        active: '活动',
        actions: '操作',
        discount_permission: '销售折扣权限',
        discount_value: '最大折扣值 (%)',
        phone: '电话号码',
      },

      groups: {
        groups: '群组',
        group: '群组',
        here_are_listed_the_groups_along_with_their_respective_actions:
          '此处列出了群组及其各自的操作',
        name: '名称',
        Integrations: '集成',
        means_of_payment: '支付方式',
        products: '产品',
        category: '类别',
        subcategory: '子类别',
        indicators: '指标',
        requests: '订单',
        reports: '报告',
        messenger: '消息',
      },

      shifts: {
        shifts: '班次',
        here_are_listed_the_shifts_for_each_day_of_the_week: '此处列出了每周每一天的班次',
        monday: '周一',
        tuesday: '周二',
        wednesday: '周三',
        thursday: '周四',
        friday: '周五',
        saturday: '周六',
        sunday: '周日',
        start: '开始',
        end: '结束',
      },

      account: {
        account: '账户',
        edit_account: '编辑账户',
        registration_number: 'CNPJ',
        corporate_name: '公司名称',
        customer_name: '名称',
        name_of_the_establishment: '场所名称',
        subdomain: '子域名',
        code: '代码',
        default_language: '默认语言',
        default_currency: '默认货币',
        login_of_person_in_charge: '账户负责人登录名',
        name_of_person_in_charge: '负责人姓名',
        address: '地址',
        zip_code: '邮政编码',
        number: '号码',
        neighbourhood: '街区',
        city: '城市',
        state: '州',
        public_place: '街道',
        address_complement: '补充',
        info: '要更改子域名，请联系支持人员',
      },

      terms: {
        terms: '条款',
        here_are_the_terms_of_acceptance_of_the_sales_platform: '此处列出了销售平台的接受条款',
        create_your_term: '创建您的条款',
        term_name: '条款名称',
        valid_until: '有效期至',
        name: '名称',
        expirated: '过期',
      },

      payment_plans: {
        payment_plans: '支付计划',
        here_are_listed_the_payment_plans_along_with_their_respective_actions:
          '此处列出了支付计划及其各自的操作',
        create_payment_plans: '创建支付计划',
        fill_the_information_below_and_click_the_create_button_to_save_the_changes:
          '填写以下信息并点击“创建”按钮保存更改',
        erp_integration: 'ERP 集成',
        integration_type: '集成类型',
        select_an_integration: '选择集成',
        card_flag: '银行卡品牌',
        flag: '品牌',
        type: '类型',
        erp_code: 'ERP 代码',
        card_installment: '分期付款',
        payment_plan: '支付计划',
        installment: '分期',
        time: '期限',
        credit: '信用',
        debit: '借记',
      },

      indicators: {
        indicators: '指标',
        orders: '订单',
        filters: '筛选',
        first: '开始',
        end: '结束',
        total_order: '订单总数',
        revenue: '收入',
        orders_by_location: '按方式划分的订单',
        orders_by_month: '按月划分的订单',
        orders_by_day: '按日划分的订单',
        orders_by_hour: '按小时划分的订单',
        orders_by_month_sector: '按月和方式划分的订单',
        orders_by_day_sector: '按日和方式划分的订单',
        orders_by_hour_sector: '按小时和方式划分的订单',
        product: '产品',
        categories: '类别',
        sales_by_category: '按类别划分的销售额',
        revenue_by_category: '按类别划分的收入',
        average_ticket: '平均客单价',
        quantity: '数量',
        summary: '摘要',
        summaryAccess: '访问',
        summaryAccessGroup: '按期间访问的区域',
        summaryTimeAccessGroup: '按小时总计',
        summaryIPAccessGroup: '按用户总计',
        summarySellerCart: '按销售创建的购物车总数',
        period: '选择期间',
        summaryTypeCust: '按成本类型汇总',
        summaryComposition: '成本构成',
        cost: '成本',
        customer: '客户',
        seller_sales_by_category: '按类别划分的销售额',
        summary_seller: '销售摘要',
        sellers_invoice: '销售发票',
        comparative_sales_by_channel: '按渠道划分的销售比较',
        select_view: '选择视图',
        sales: '销售额',
        attended_customers: '服务客户',
        carts: '已保存的购物车',
        sales_conversion: '销售转化率',
        mean_ticket: '平均客单价',
        sales_client: '按客户划分的销售比较/排名',
        sellers: '销售人员',
        summary_store: '商店摘要',
        accesses: '访问',
        active_sellers: '活动销售人员',
        revenue_store: '商店收入',
        revenue_group: '群组收入',
        comparative_sales_by_seller: '按销售人员划分的销售比较',
        comparative_sales_by_store: '业务单位比较',
        comparative_by_seller: '销售力量 - 销售人员比较',
        stores: '商店',
        invoicing: '收入',
        active_stores: '活动商店',
        summary_group: '群组摘要',
        invoice_by_store: '按商店划分的收入',
        rank_sellers: '销售人员排名',
        rank_stores: '商店排名',
      },

      customer_list: {
        customer_list: '客户列表',
        listed_customers: '此处列出了客户及其各自的操作。',
        select_time: '已完成订单的期间',
        name: '名称',
        first: '开始',
        end: '结束',
        phone: '电话',
        date: '日期',
        detail: '客户详情',
        total_profit: '总利润',
        total_itens: '项目总数',
        total_orders: '订单总数',
        order_between: '订单介于',
        order_detail: '订单详情',
        create: '创建客户',
        go_detail: '查看详情',
        product: '产品',
        value: '价值',
        quantity: '数量',
        total: '总计',
        edit: '编辑客户',
      },

      smart_order: {
        smart_order: '智能点餐',
        service_classification: '服务分类',
        message_warning_find_variation:
          '注意：在搜索变体时，请确保输入完整的 SKU 或 EAN 代码以获得准确的结果。',
        product: '产品',
        create_product: '创建产品',
        here_are_listed_the_products_along_with_their_respective_actions:
          '此处列出了产品及其各自的操作',
        name: '名称',
        code: '代码',
        crop_image: '裁剪图片',
        use_original_image: '使用原始图片',
        select_image_format: '选择图片格式',
        use_selected_size: '使用所选尺寸',
        format_640x640: '640x640 (正方形)',
        format_600x900: '600x900 (肖像)',
        product_data: '产品数据',
        mark: '品牌',
        measurement_unit: '计量单位',
        description: '描述',
        technical_specification: '技术规格',
        from: '从',
        characters: '个字符',
        order: '顺序',
        product_image: '产品图片',
        additional_images: '附加图片',
        product_groups: '产品的客户群组',
        categories: '类别',
        here_are_listed_the_categories_along_with_their_respective_actions:
          '此处列出了类别及其各自的操作',
        image: '产品图片',
        image_variation: '变体图片',
        category: '类别',
        category_parent: '父类别',
        category_name: '类别名称',
        category_code: '类别代码',
        perfil_image: '个人资料图片',

        subcategories: '子类别',
        subcategory: '子类别',
        here_are_listed_the_subcategories_along_with_their_respective_actionsc:
          '此处列出了子类别及其各自的操作',
        select_category: '选择类别',

        marks: '品牌',
        listened_marks: '此处列出了品牌及其各自的操作',

        measurements_units: '计量单位',
        listened_measurement: '此处列出了计量单位及其各自的操作',

        grid_products: '网格',
        listened_grid: '此处列出了产品网格及其各自的操作',
        grid_name: '网格名称',
        grid_code: '代码',
        variation: '变体',
        grid: '网格',
        grids: '网格',

        variations: '变体',
        listened_variations: '此处列出了产品变体及其各自的操作',
        modality: '方式',
        select_modality: '选择方式',
        prod: '产品',
        select_product: '选择产品',
        no_variation: '无变体产品',
        variation_product: '产品变体',
        cost_price: '成本价',
        sell_price: '销售价',
        promotional_price: '促销价',
        weight: '重量',
        height: '高度',
        width: '宽度',
        depth: '深度',
        availability: '产品的可用性如何？',
        when_product_stock: '当产品缺货时？',
        stock: '库存产品数量',
        min_stock: '最小库存',
        price: '价格',

        catalogs: '目录',
        catalog: '目录',
        create_catalog: '创建目录',
        edit_catalog: '编辑目录',
        catalog_link: '复制目录链接',
        listened_catalogs: '此处列出了产品目录及其各自的操作。',
        validity: '有效期',
        first: '开始',
        end: '结束',
        search_products: '产品搜索',

        product_status: '产品状态',
        sku: 'SKU/EAN',
        status_variation: '变体状态',
        specification: '规格',
        price_promotional: '折扣价',
        inventory: '库存',
        preparation_time: '准备时间',
        service_title: '此处列出了服务及其各自的操作。',

        initial_hour: '开始时间',
        final_hour: '结束时间',

        date_start: '开始日期',
        date_end: '结束日期',

        add_group: '附加项目列表',
        no_add: '此产品尚未与任何附加项目列表关联。',
        already_add: '此产品与以下附加项目列表关联。',
        associate_add: '关联到附加项目列表',
        associate: '关联',
        choose_add: '选择将与此产品关联的附加项目列表。',
        no_group_add: '没有可关联的附加项目列表。',
        remove_add: '移除关联',
        remove_add_text: '您确定要移除此产品与附加项目列表 “@” 的关联吗？',
        limit_range: '达到最大间隔限制',

        remove_add_soon:
          '注意！此标签页将很快被移除。您仍可正常管理您的附加项目。请访问“基本信息”标签页，然后转到“附加项目群组”部分查看此产品的附加项目。',
        create_image_ia: '人工智能图片提议',
        create_image_ia_text: '输入产品描述以生成图片。',
        generate_images: '生成图片',
        generate_description: '个性化描述',
        generate_new_options: '生成新选项',
        save_image_selected: '保存所选照片',
        reference_image_ia: '参考图片',
        image_qtd_ia: '图片数量',
        save_img_ia: '保存图片',
        cancel: '取消',

        more_category: '查看此类别更多配置',
        selectAll: '全选',
        alterLot: '更改批次',
        edit_category: '不允许更改类别关联，建议您创建新类别',

        catalog_image: '目录图片',
      },

      service_grid: {
        service_grid: '服务网格',
        service_grid_single: '服务网格',
        create_service_grid: '创建服务网格',
        edit_service_grid: '编辑服务网格',
        service_grid_name: '服务网格名称',
        service_grid_name_placeholder: '服务网格名称',
        start_hour: '开始时间',
        start_hour_placeholder: '00:00',
        end_hour: '结束时间',
        end_hour_placeholder: '23:59',
        interval: '间隔',
        interval_placeholder: '00:15',
        interval_tooltip: '订单之间的时间间隔',
        service_list: '服务列表',
        service_placeholder: '服务',
        missing_fields: '缺少字段',
        missing_fields_message: '请检查您是否填写了所有字段！',
        grid_created: '网格已注册',
        grid_created_message: '注册成功！',
        grid_updated: '网格已更改',
        grid_updated_message: '编辑成功！',
        error: '错误',
        error_create_message: '注册网格时出错！',
        error_update_message: '更改网格时出错！',
        fill_information_create: '填写以下信息并点击“创建”按钮保存更改',
        save_changes_edit: '填写以下信息并点击“保存”按钮确认更改',
        dashboard: '仪表盘',
        title: '标题',
        listed_grids: '此处列出了服务网格及其各自的操作',
        grid_deleted: '网格已删除',
        grid_deleted_message: '删除成功！',
        error_delete_message: '删除网格时出错！',
        status: '状态',
        grid_linked_warning: '网格已关联',
        grid_linked_message: '此网格已关联到 {count} 个服务表单，无法删除。',
      },

      webapp: {
        webapp: 'Webapp',
        generate_qrcode: '生成二维码',
        personalize: '个性化',
        settings: '设置',
        link: 'Webapp 链接',

        webapp_data: 'Webapp 数据',
        name: '名称',
        place: '地点',
        product_pagination: '分页中的产品数量',
        logo_ninegrid: 'Ninegrid 标志',
        light: '浅色',
        dark: '深色',
        logo_totvs: 'TOTVS 标志',
        use_icon_menu: '在 Webapp 菜单中使用图标',
        description: '描述',
        icon: '图标',
        color_setting: '颜色配置',
        background_webapp: 'Webapp 背景',
        background_default_webapp: 'Webapp 默认颜色',
        background_header: '页眉背景',
        text_header: '页眉文本',
        icon_header: '页眉图标',
        background_footer: '页脚背景',
        icon_footer: '页脚图标',
        highlight_footer: '页脚高亮',
        notification_cart: '购物车通知',
        notification_text: '通知文本',
        home_button: '主页按钮',
        text_home_button: '主页按钮文本',
        title_bar: '标题栏',
        text_title_bar: '标题栏文本',
        icon_title_bar: '标题栏图标',
        text_category: '类别文本',
        webapp_button: 'Webapp 主题',
        text_button: '按钮文本',
        background_menu: '侧边菜单背景',
        text_menu: '侧边菜单文本',
        price_card_background: '价格卡片背景',
        price_card_font_color: '价格卡片字体颜色',
        order_status: '订单状态',
        order_active_status: '活动订单状态',
        text_order_active_status: '订单状态文本',
        info_cart: '购物车信息',

        settings_webapp: 'Webapp 设置',
        type_delivery: '配送限制类型',
        integration: '集成',
        select_integration: '选择集成',
        payment_method_card: '支付方式 卡',
        payment_method_pix: '支付方式 Pix',
        payment_method_delivery: '货到付款',
        consent_letter: '启用同意书',
        product_no_stock: '销售缺货产品',
        show_subcategory: '显示子类别',
        show_observation: '显示备注',
        use_category_list: '以列表形式显示子类别和产品',
        use_category_list_v2: '以列表形式显示类别和子类别',
        use_product_list: '以列表形式显示产品',
        remove_shadow: '不对类别和目录添加阴影',
        remove_show_mode: '移除显示模式',
        no_shadow: '不对类别添加阴影',
        is_order_number: '排序类别',
        order_number: '按顺序',
        order_category: '按字母顺序',
        show_layout: '显示布局',
        image_type: '产品图片样式',

        withdraw_fee: '取货费',
        minimum_value: '最小订单价值',
        seller_checkout: '结账方式',

        no_sales: '不允许销售',
        safe_mode: '安全模式',
        time_safe_mode: '安全模式会话时间（分钟）',
        limit_characteres_explanation:
          '对于使用 Wintor 或 Protheus 集成的商店，建议最多 50 个字符。',
        limit_characteres: '字符限制',

        skip_entry: '跳过进入屏幕',
        payment_table: '桌上支付',

        payment_card: '订单支付',

        slides_homePage: '主页精选图片',
        slides_initial: '初始精选图片',

        slides_not_found: '未找到任何幻灯片图片',

        externalLink: '外部链接',
        buttonType: '按钮类型',
        ableUserLocation: '允许按位置搜索地址',
        ableWaiter: '禁用呼叫服务员选项',
        closeAccountButton: '移除关闭账户按钮',
        emitNfChef: '在订单付款后开具发票？ (柜台/桌子/订单)',

        seller_cart_limit_time: '销售购物车过期时间（小时）',
        seller_cart_limit_time_explanation: '客户可以使用销售购物车的最大时间',
        settings_webapp_aggregator: '个性化',
        generate_qrcode_webapp_aggregator: '生成二维码',
        qrcode_webapp_aggregator: 'Web 应用程序',
        security_settings: '安全设置',
        maximus_radius: '位置：允许的最大接近半径（米）',
        access_maximus: '每张桌子的最大访问次数',
        limit_time: '订单过期前的访问时间（分钟）',
        password: '解锁访问密码',
        flag_discount: '折扣标签格式',
        color_flag_discount: '标签颜色',

        config_tags: '配置标签',
        promotional_tags: '促销标签',

        pre_created: '预注册',

        show_classification_button: '显示查看所有类别的按钮',
        show_catalog_button: '显示查看所有目录的按钮',
        show_catalog_name: '显示目录名称',
        show_classification_name: '显示类别名称',
        show_mark_name: '显示产品品牌',
        show_stock_quantity: '显示产品库存',
        show_promotional_tags: '显示促销标签',
        show_product_sku: '显示产品 sku',
        text_free_delivery: '免费配送或取货的自定义文本',
        tooltip_free_delivery: '如果填写，当配送或取货免费时将显示此文本。如果为空，将显示 R$ 0,00',
        place_holder_free_delivery: '例如: 免费',
        no_show_grid: '省略产品单个变体的网格',
        explain_show_grid:
          '隐藏具有单个变体的网格。具有多个选项的网格（例如: 尺码 L; XL）将在产品选择中保持可见，但在其他地方隐藏。',

        type_image: '图片类型',
        type_image_square: '方形',
        type_image_rectangle: '矩形',

        directlink: '直接链接',
        infoDirectLink: '非强制性，仅在需要直接发送到其他页面或网站时使用，最多 350 个字符',

        block_add_in_limit: '限制内阻止添加',

        family_fonte: '字体系列',
        rounding_images: '图片圆角',
        rounding_bars: '条形圆角',
        color_icons: '图标颜色',
        color_icons_header_footer: '页眉和页脚中的图标颜色',
        background_icon_button: '图标背景颜色',
        background_icon_custom: '自定义颜色',
        restaurant_list: '以列表形式显示餐厅',
        restaurant_display_mode: '更改餐厅显示模式',
        icon_button_size: '按钮图标大小',
        shadow_image: '图片阴影',
        black_logo_nine: '深色 Ninegrid 标志',
        skip_loud_screen: '跳过加载屏幕',
        can_acesse_restaurant: '允许在未登录的情况下查看目录（商店/餐厅）',
        info_acesse_restaurant:
          '启用此标志允许用户在无需登录的情况下访问餐厅或商店菜单/目录。如果存在活动的支付集成，则会在支付步骤之前直接在商店或餐厅的WebApp中要求登录，以便订单正确关联到酒店系统中的用户上下文（个人资料/预订）。',
      },

      integration: {
        integration: '集成',
        means_of_payment: '支付方式',
        here_are_listed_the_means_of_payment_along_with_their_respective_actions:
          '此处列出了支付方式及其各自的操作',
        PDV: 'POS 集成',
        listed_here_are_the_integrations_along_with_their_respective_actions:
          '此处列出了集成及其各自的操作',
        integration_name: '集成名称',
        type_of_integration: '集成类型',
        actions: '操作',
        search: '搜索',
        example: 'Payload 示例',

        loads: '负荷',
        name: '名称',
        price: '价格',
        stock: '库存',
        measurements_units: '计量单位',
        grid: '网格',
        classifications: '类别',
        products: '产品',
        status_sync: '状态同步',
        marks: '品牌',
        orders: '订单',
        trigger_load: '触发负荷',
        first: '开始',
        end: '结束',
        load: '加载',
        messenger: '消息',
        others: '其他',
        test: '您要测试集成吗',
        params_test: '查看此集成参数',
        copy_params: '复制参数',
        result_test: '集成测试结果',
        success_1: '成功！集成',
        success_2: '成功。',
        result_log: '结果日志',
        copy_result: '复制结果',
        search_result: '在结果中搜索',
        error_1: '集成',
        error_2: '返回错误。请查看下方日志了解更多信息。',

        success_food_1: '成功！集成',
        success_food_2: '成功。',
        error_food_1: '集成',
        error_food_2: '返回离线。',

        integrationPrint: '测试连接',
      },

      reports: {
        orders: '订单',
        order_report: '订单报告',
        order_list: '订单列表',
        first: '开始',
        end: '结束',
        firstTime: '开始时间',
        endTime: '结束时间',
        orders_between: '订单介于',
        order_number: '订单编号',
        date: '日期',
        consumer: '消费者',
        modality: '方式',
        total_value: '价值',
        cancel_order: '取消订单',

        products: '产品',
        quantity: '数量',
        qtt: '数量',
        product: '产品',
        value: '价值',
        total: '总计',
        order_status: '订单状态',
        payment_method: '支付方式',
        billing_address: '账单地址',
        product_value: '产品价值',
        discount: '折扣',
        order: '订单',

        listened_logs: '此处列出了日志及其各自的操作。',
        methods: '方法',
        log_details: '日志详情',

        withdraw: '取货',
        delivery: '配送',
        table: '桌子',
        counter: '柜台',
        responsible_withdraw: '取货负责人',
        responsible_delivery: '接收负责人',
        address_withdraw: '取货地址',
        address_delivery: '配送地址',
        seller: '销售人员',
        seller_link: '销售链接',
        external_code: '外部编号',
        payment: '付款',
        internal_delivery: '内部配送',
        origin: '来源',
        historial: '订单历史',
        approval_moment: '批准日期和时间',
        id: '预订代码',
        pluginspace: '酒店',
        hotel: '与酒店关联的订单',
        document: '预订文件',
        room: '客房代码',
        status_payment: '付款状态',
        authorization_code: '授权码',
        transaction: '交易 ID',
        made_in: '执行于',
        send_method: '发送方式',
        send_date: '发送日期',
        estimated_delivery: '预计配送',
        freight: '运费',
        tracking_code: '跟踪代码',
        website: '打开跟踪网站',
        label: '打印发货标签',
        payment_delivery: '货到付款',
        payment_money: '现金支付',
        change_money: '找零',
        label_code: '标签',
        label_website: '打开标签网站',
        declaration_code: '声明',
        declaration_website: '打开声明网站',
        height: '高度 (cm)',
        width: '宽度 (cm)',
        length: '长度 (cm)',
        weight: '重量 (kg)',
        send_text: '客户选择的发送方式：',
        success_label: '您的发货标签已成功生成。',
        continue: '继续',
        confirm: '确认',
        change_multiple_status: '更改多个订单的状态',
        change_status_text: '您要更改以下订单的状态吗？',
        new_status: '新状态',
        change_status: '更改状态',

        synkar: '自动化',
        invalid_data: '请选择开始和结束日期。',

        details: '详情',
      },

      imports: {
        imports: '导入',
        import_image_product: '产品图片导入',
        import_image_category: '类别图片导入',
        listened_import_product: '此处列出了产品图片导入及其各自的操作。',
        no_upload_images: '不执行图片上传',
        first: '开始',
        end: '结束',
        total_products: '产品总数',
        sync_products: '已同步产品',
        import_image_sku: '变体图片导入',
        listened_import_sku: '此处列出了变体图片导入及其各自的操作。',
        verify_verification: '变体验证',
        product_code: '产品代码',
        code: '代码',
        total_variations: '变体总数',
        sync_variations: '已同步变体',
        total_categories: '类别总数',
        sync_categories: '已同步类别',
        problem_title: '有问题图片',
        images_success: '图片发送成功。',
        images_error: '图片出现问题且未发送。',
        file: '文件',
        status: '导入状态',
        new_import: '执行新导入',
        import_xls: '使用 XLS 文件导入图片',
        import_repo: '从 Google Drive 或 Dropbox 导入图片',
        steps: '导入步骤',
        step_1: '1. 将所有图片放在公共 Web 服务器上。',
        step_2: '2. 检查服务器是否为公共且可通过 Web 访问。',
        step_3: '3. 下载我们的空白 XLSX 文件。',
        step_4: '4. 填写您的图片库数据。',
        step_5: '5. 上传已填写的文件。',
        step_1_repo: '1. 检查商店文件夹是否创建为 "fotos_loja_<store_identifier>"。',
        step_2_repo: '2. 在您的商店文件夹中创建“produtos”文件夹。',
        step_2_repo_sku: '2. 在您的商店文件夹中创建“variacoes”文件夹。',
        step_2_repo_category: '2. 在您的商店文件夹中创建“categorias”文件夹。',
        step_3_repo: '3. 确认文件格式为 "<product_code>.<extension>"。',
        step_3_repo_sku: '3. 确认文件格式为 "<sku>.<extension>"。',
        step_3_repo_category: '3. 确认文件格式为 "<category_code>.<extension>"。',
        step_4_repo: '4. 如果是附加产品，请检查是否带有 "_<number>"。',
        step_4_repo_sku: '4. 确认变体是图片且格式为 JPG 或 PNG。',
        step_4_repo_category: '4. 确认类别是图片且格式为 JPG 或 PNG。',
        step_5_repo: '5. 确认产品是图片且格式为 JPG 或 PNG。',
        download: '下载空白 XLSX 文件',
        download_problems: '导出报告',
        upload: '发送文件',
        upload_anex: '附加文件',
        import_dropbox: '使用 Dropbox 导入',
        import_drive: '使用 Google Drive 导入',
        spreadsheet: '电子表格',
        gdrive: 'Google Drive',
        dropbox: 'Dropbox',
        type: '类型',
        type_resize: '调整大小类型',
        agroup_color: '按颜色分组照片',
        banner_size: '将 N1 类别视为横幅',
        select_dimensions: '选择尺寸',
        square: '视为 640x640',
        vertical: '视为 600x900',
      },

      sms: {
        sms: '短信',
        listened_sms: '此处列出了消息（短信）及其各自的操作。',
        order: '订单',
        name: '名称',
        message: '消息',
        markers: '标记 [pedido] 和 [status] 必须在消息中',
        waiting: '等待中',
        opened: '未结清',
        ready: '就绪',
        refused: '已拒绝',
      },

      multichannel: {
        multichannel: '多渠道',
        listened_multichannel: '此处列出了多渠道配置及其各自的操作。',
      },

      feed: {
        content: '内容',
        title: '标题',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          '填写以下信息并点击“创建”按钮保存更改',
      },
      feedCategory: {
        feedCategory: '内容类别',
      },

      structured_content: {},

      queue: {
        index: '等候队列',
        menage: '管理',
        config: '等候队列配置',
        able: '允许等候队列',
        link: '等候队列链接：',
        limit_people: '最大人数',
        limit_people_text: '等候队列限制',
        limit_time: '显示警报的时间限制',
        limit_time_text: '被视为延迟的最大时间（分钟）',
        image_title: '图片定义',
        image_text:
          '队列系统显示 2 张图片。上传您的餐厅照片，或在下方选择默认照片。上传的照片将被调整为 350x250 像素的大小。',
        image: '图片',
        position: '位置',
        time: '等待时间',
        people: '人',
        cancel: '取消',
        cancel_text: '您要将此人从等候队列中移除吗？',
        cancel_button: '移除',
        confirm: '确认',
        confirm_text: '您要确认预订者的到来吗？',
        confirm_button: '确认到达',
        empty: '目前没有等候列表',
        confirm_all: '确认全部',
        cancel_all: '取消全部',
        observation: '备注',
        use_terms: '启用同意条款',
        total_people: '每组总人数',
        total_people_text: '每组等候队列限制',
        all: '全部',
        in_queue: '在队列中',
        preferential: '优先',
        confirmed: '已确认',
        removed: '已拒绝',
        show: '显示',
        show_text: '最近 @ 小时',
        yes: '是',
        no: '否',
        add: '将客户添加到队列',
        use_location: '允许定位？',
        use_menu: '您要使用菜单吗？',
        use_ninegrid_menu: '使用 Ninegrid 菜单？',
        external_menu_link: '输入菜单链接',
        edit: '编辑队列中的客户',
      },
      booking: {
        index: '预订',
        config: '预订配置',
        able: '允许预订',
        link: '预订链接：',
        image_title: '图片定义',
        image_text:
          '预订系统显示 2 张图片。上传您的餐厅照片，或在下方选择默认照片。上传的照片将被调整为 350x250 像素的大小。',
        image: '图片',
        days_week: '星期几',
        booking_day: '允许在这一天预订吗？',
        booking_day_text: '在下方定义允许预订的时间。',
        booking_day_subtext:
          '选择一个时间将定义一个 1 小时的时间窗口。例如：选择 19:00，人们可以在 19:00 到 20:00 之间进行预订。',
        max_people: '每次预订的最大人数',
        max_people_text: '这是可以进行预订的一组人的最大规模',
        expiry_time: '预订过期前的最长时间',
        expiry_time_text: '等待预订者到达的最大时间（分钟）',
        day_confirm: '要求当天确认',
        day_confirm_text: '用户需要在所选日期确认预订',
        payment_confirm: '要求预订时预付款',
        value_payment_confirm: '预付款价值',
        week: '周',
        month: '月',
        year: '年',
        use_terms: '启用同意条款',
        empty: '目前没有预订',
        use_time: '允许按期间预订',
        time: '预订持续时间 (HH:mm)',
      },
      booking_day: {
        booking: '当日预订',
        date: '日期',
        people: '人',
        expiry: '过期时间',
        cancel_title: '取消',
        cancel_subtitle: '您要取消此预订吗？',
        cancel_button: '取消预订',
        confirm_title: '确认',
        confirm_subtitle: '您要确认预订者的到来吗？',
        confirm_button: '确认到达',
        accessibility_needs: '无障碍需求',
        accessibility_elderly: '老年人支持',
        accessibility_wheelchair: '轮椅使用者',
        accessibility_physical: '身体残疾',
        filter_accessibility: '按无障碍筛选',
        all_accessibility: '所有需求',
      },
      booking_report: {
        report: '报告',
        search: '预订搜索',
        time: '选择期间',
        date_start: '开始日期',
        date_end: '结束日期',
        confirm: '确认',
        noShow: '未入住',
        confirmed: '已确认预订',
        canceled: '已取消预订',
        open: '未结清',
        map: '预订地图',
        booking: '预订',
        accessibility_stats: '无障碍统计',
        accessibility_total: '有需求总数',
        accessibility_percentage: '百分比',
      },
      booking_report_management: {
        management: '预订管理',
        search: '预订搜索',
        phone: '电话',
        date_start: '开始日期',
        date_end: '结束日期',
        today: '今天',
        tomorrow: '明天',
        calendar: '日历',
        see_all: '查看全部',
        people: '人',
        noShow: '未入住',
        confirmed: '已确认',
        canceled: '已取消',
        open: '未结清',
        search_text: '电话搜索或日期选择结果',
      },
      environment: {
        map: '环境地图',
        environment: '环境',
        index: '环境',
        name: '环境名称',
        tables: '桌子数量',
        seats_available: '可用座位总数',
        actions: '操作',
      },
      week_day: {
        sun: '周日',
        mon: '周一',
        tue: '周二',
        wed: '周三',
        thur: '周四',
        fri: '周五',
        sat: '周六',
      },
      week_day_full: {
        sun: '星期日',
        mon: '星期一',
        tue: '星期二',
        wed: '星期三',
        thur: '星期四',
        fri: '星期五',
        sat: '星期六',
      },
      checkout: {
        title: '客户数据',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          '此处列出了创建客户所需的字段。',
        active_mandatory: '必填字段',
        active_visibility: '可见字段',
      },

      liveShop: {
        liveShop: '实时商务',
        liveShop_list: '此处列出了实时商务活动及其各自的操作。',
        create: '创建实时商务',
        edit: '编辑实时商务',
        dateInit: '开始',
        hourInit: '开始时间',
        dateEnd: '结束',
        hourEnd: '结束时间',
        status: '状态',
        initDate: '开始日期和时间',
        fimDate: '结束日期和时间',
        name: '名称',
        variations: '产品变体',
        search_products_Attentions: '返回的产品和变体必须处于激活状态，有价格、库存和图片',
        alert_delete: '活动开始或结束后无法移除！',
        alert_Edit: '活动开始或结束后无法编辑！',
        delete: '删除实时商务',
      },

      logs: {
        //PagSeguro
        pagseguroPaymentCodePhone: 'Pagseguro 电话代码错误',
        pagseguroPaymentErrorCountry: 'Pagseguro 国家代码错误',
        pagseguroPaymentErrorEmail: 'Pagseguro 电子邮件错误',
        authenticatePagseguro: 'Pagseguro 认证',
        pagseguroPayment: 'Pagseguro 付款',
        pagseguroPaymentCatch: 'Pagseguro 付款',
        pagseguroPaymentResponse: 'Pagseguro 付款响应',
        pagseguroPaymentTransactions: 'Pagseguro 付款交易',
        pagseguroReturnPayment: 'Pagseguro 付款返回',
        paymentPixPagseguro: 'Pagseguro Pix 付款',

        pagseguroPaymentGateway: 'Pagseguro 支付网关',
        getAuthPagseguroEmailSpace: '按电子邮件进行 Pagseguro 认证',
        getOneApplicationClientId: '获取 Pagseguro 客户端应用程序',
        createAuthPagseguro: '创建 Pagseguro 认证',
        generatePublicKeyPagseguro: '生成 Pagseguro 公钥',
        updateCodeRedirectApplication: '更新 Pagseguro 应用程序代码',
        deleteAuthPagseguroByEmail: '移除 Pagseguro 认证',
        createPluginconfig: '插件配置',

        //Totvs 支付 HUB
        refundTotvs: '通过 Totvs 退款',
        refundPayCard: '通过 Totvs 银行卡退款',
        paymentTotvs: '通过 Totvs 付款',
        paymentPixTotvs: '通过 Totvs Pix 付款',

        //银行卡结构
        sendUnregisteredCardBrands: '未找到品牌',
        cardStructure: '银行卡结构',
        cardStructureInvalidPlugin: '网关的插件无效',
        cardStructureGatewayError: '网关的银行卡错误',
        cardStructureData: '银行卡数据',
        cardStructureError: '银行卡数据错误',
        cardStructureDecrypt: '银行卡解密',
        cardStructureFields: '银行卡字段',
        refundCard: '银行卡退款',

        //状态
        analysisSatusOrder: '用于分析的订单状态',
        statusPayPix: 'Pix 状态',

        //反欺诈
        analyseAntifraud: '反欺诈分析',
        dataClearSale: 'ClearSale 数据',
        statusAnalysis: '分析状态',

        //库存
        addSkuInventory: '添加到库存',
        subtractSku: '从库存中移除',
        viewCargoHistory: '查看负荷历史',
        viewCargoHistoryBySku: '按 SKU 查看负荷历史',

        // 订单-Pedido
        sendOrderIn: '订单发送',
        cancelOrder: '取消订单',
        sendOrder: '发送订单',
        sendOrderRefund: '订单退款',
        sendOrderError: '发送订单时出错',
        sendOrderResultRefund: '订单退款结果',
        sendOrderResultData: '订单发送结果',
        sendOrderAntifrud: '订单发送中的反欺诈',
        sendOrderPaymentStruct: '订单付款结构',

        sendOrderDescryptor: '订单解密',
        sendOrderStatus: '订单状态',
        sendOrderConfigNotFound: '未找到订单发送配置',
        sendOrderMandatoryCustomer: '订单客户',
        sendOrderMandatory: '订单强制结构',
        sendOrderResultGateway: '发送到网关的结果',
        OrderFashionService: '时尚订单服务',
        OrderFashionServiceError: '时尚订单服务错误',
        cartOrderLive: '实时订单购物车',
        cartOrderLiveError: '实时订单购物车错误',
        sendOrderErrorGeral: '订单错误',
        sendPushNotification: '发送推送通知',

        //预订单
        preOrderStatusPix: '通过 Pix 的预订单状态',
        processQueuePreOrder: '预订单队列处理',
        getAllPreOrderBySpace: '按 Pluginspace 获取所有预订单',
        sendPreOrder: '发送预订单',
        makeOrderTransparent: '订单验证',
        statusPreOrder: '预订单 Pix 状态更新',
        preOrderStatusCanceledPix: '通过 Pix 取消预订单',

        //Totvs Wintor
        buildOrderTotvsWinthor: '创建订单',
        sendOrderWinthor: '将订单发送到 Totvs',
        sendCustomerOrderWinthor: '将客户发送到 Totvs',

        //Totvs 零售
        buildOrderTotvsVarejo: '创建订单',
        setConfimTicket: '票证确认',
        SyncOrderLive: '订单同步',
        ObterProdutos: '获取产品',
        taskPrice: '价格负荷',
        calculationPromotion: '促销计算',
        PayloadCalcPromotion: '促销计算 Payload',

        //Totvs 时尚
        changeStatus: '状态更改',
        sendOrderFashion: '将订单发送到 Totvs',
        sendCustomerFashion: '将客户发送到 Totvs',
        searchPersonTotvsByCPF: 'Totvs 客户搜索',
        sendErrorCustomerFashion: '将客户发送到时尚时出错',
        buildCustomerTotvsFashion: '在 Totvs 中创建客户',
        ResumeSnyOrderFashion: '与时尚同步摘要',
        changeStatusFashion: '更改状态',
        buildOrderTotvsFashion: '创建时尚订单',

        //Totvs 餐饮
        updateStatusOrderFoodIntegration: '状态更改',
        buildOrderTotvsFood: '创建订单',
        changeStatusOrderFood: '状态更改',
        sendOrderTotvsFood: '将订单发送到 Totvs',
        confirmMenu: '菜单已确认',
        getMenu: '获取 Totvs 菜单',

        //Totvs 实时
        sendCustomerLive: '实时客户发送',
        sendOrderLive: '实时订单发送',

        //Synkar
        updateStatusOrderSynkar: 'Synkar 订单更新',
        sendingOrderMessageSynkar: 'Synkar 消息发送',
        responseOrderMessageSynkar: 'Synkar 消息响应',
        sendingOrderSynkar: 'Synkar 发送',
        responseOrderSynkar: 'Synkar 响应',

        //SDS
        sdsGetOrders: '获取 SDS 订单',
        sdsOrderIn: 'SDS 订单发送',
        sdsOrderInResult: '发送订单到 SDS',
        sdsSyncCardapio: '菜单与 SDS 同步',
        'sendOrderfood-sdsOrderIn': '发送 SDS 订单时出错',

        //S3
        createRoute: '创建 S3 路由',
        getStatusfiftythree: '路由 53 状态',
        updateDistribution: '更新分发',
        deleteRoute: '删除 S3 路由',
        deleteDistribution: '删除分发',

        //Erede
        refundErede: 'Erede 退款',
        paymentErede: 'Erede 付款',

        //Cielo
        refundCielo: 'Cielo 退款',
        paymentCielo: 'Cielo 付款',

        //Pagseguro
        refundPagseguro: 'Pagseguro 退款',
        getApplicationPagseguro: 'Pagseguro 应用程序网关',

        //离线支付
        paymentOffline: '货到付款',

        //一般
        chargeSyncOrderErro: '状态同步错误',
        chargeSyncOrder: '状态同步',
        chargeProductLive: '实时产品同步',
        chargeBalanceLive: '实时库存同步',
        chargePriceLive: '实时价格同步',
        chargeProductLiveErro: '实时产品同步错误',
        chargeBalanceLiveErro: '实时库存同步错误',
        chargePriceLiveErro: '实时价格同步错误',

        chargeProduct: '产品同步',
        chargeBalance: '库存同步',
        chargePrice: '价格同步',
        chargeProductErro: '产品同步错误',
        chargeBalanceErro: '库存同步错误',
        chargePriceErro: '价格同步错误',

        taskBalanceIntegration: '库存负荷集成',
        taskBalanceCharge: '库存负荷已启动',
        SnyOrder: '订单状态同步',
        syncronyzePriceInteration: '价格负荷',
        syncronyzePrice: '价格同步',
        chargeClassification: '类别和子类别负荷',
        chargeGrid: '网格负荷',
        chargeGridItens: '网格负荷项目',
        chargeMeasure: '计量单位负荷',
        deleteAllProducts: '删除所有产品',

        chargeGridToken: '网格负荷 Token',
        classificationChargeToken: '分类负荷 Token',
        syncronyzeBalanceToken: '库存同步 Token',
        syncronyzePriceToken: '价格同步 Token',
        chargeMeasureToken: '计量单位负荷 Token',
        taskClassificationBySpace: '分类负荷',
        syncStatusOrderPayload: '订单状态同步 Payload',
        syncStatusOrder: '订单状态同步',
        syncStatusOrderToken: '订单状态同步 Token',
        syncronyzeBalancePayload: '库存同步 Payload',
        syncronyzeBalance: '库存同步',
        taskBalanceChargeBySpace: '库存负荷',
        syncronyzePricePayload: '价格同步 Payload',
        priceSkuVariationItens: '变体项目的价格',
        configSyncOrderBySpace: '订单同步配置',
        configSyncOrder: '订单同步配置',
        taskGridChargeBySpace: '网格负荷',
        productChargeInternal: '产品负荷',
        taskChargeProductBySpace: '产品负荷',
        skuLocationVariation: '按位置的变体同步',
        stockSkuVariation: '变体同步',
        taskPriceChargeBySpace: '按 Pluginspace 的价格负荷',

        automaticChargeBalance: '自动库存同步',
        automaticChargePrice: '自动价格同步',
        automaticChargeClassification: '自动分类同步',
        automaticTaskGridCharge: '自动网格同步',
        automaticTaskMeassure: '自动计量单位同步',
        automaticSnyOrder: '自动订单状态同步',
        chargeMeasureItens: '计量单位负荷项目',
        searchMeasurementAll: '计量单位负荷',
        taskGridCharge: '网格负荷',
        taskMeassure: '计量单位负荷',

        getCredential: '获取 Token',
        LoadPricePerList: '价格负荷',
        processPriceList: '价格列表处理',
        updateProductKit: '产品更新',
        UpdateProductSingle: '产品更新',
        updateProductStatus: '产品状态更新',
        taskBalanceIntegrationLink: '库存集成链接',
        taskPriceIntegrationLink: '价格集成链接',
        taskProductIntegrationLink: '产品集成链接',
        token: 'Token 获取',
        automaticChargeProduct: '自动产品负荷',

        //Ninegrid 折扣
        calculateDiscount: 'Ninegrid 中的折扣计算',
        sendDiscountNinegrid: 'Ninegrid 折扣',

        //客户购物车
        updateCustomerCartStatus: '客户购物车更新',

        //客户
        createCustomer: '客户创建',
        validCodeCustomer: '客户验证码',

        //clearSale
        statusAnalisis: '状态分析',
        antifraudValidation: '反欺诈验证',
        clearSale: 'ClearSale 保证',
        searchOrderStatusClearSale: '搜索 ClearSale 状态',

        printLabelFrenet: 'Frenet 标签',
        changeStatusFrenet: 'Frenet 状态更改',
        callWaiter: '呼叫服务员',
        paymentTable: '桌上支付',

        // 厨师发票生成
        generateNfOrderFood: '生成订单发票',
        getNotaFiscalChef: '获取厨师发票',
        finishOrderFood: '发票前检查',

        // 厨师订单错误日志
        buildCardData: '创建订单数据时出错',
        buildTableData: '创建桌子数据时出错',
        buildTablePaymentData: '创建桌上支付数据时出错',
        buildCounterData: '创建柜台数据时出错',
        buildDeliveryData: '创建配送/取货数据时出错',

        generateCustomerWholeSalerByCSV: '通过 CSV 生成批发客户',

        validateStockWholeSaleCart: '订单警报',
        validateWholeSaleCart: '订单警报',

        chargeImageService: '图片负荷服务',

        webhookNisRedis: '商店 Redis 清理',

        /*发送邮件  */
        sendEmailWelcome: '发送欢迎邮件',
        sendEmailOrderNotification: '通过邮件发送订单通知',
        sendEmailAccountNotification: '通过邮件发送账户通知',
        createCustomerLogin: '发送客户登录创建邮件',
      },

      copy: {
        definition: 'Pluginspace 定义',
        origin: '选择源 Pluginspace',
        destination: '选择目标 Pluginspace',
        configurations: '复制配置',
        store: '商店设置',
        deliveryFee: '配送费',
        shifts: '班次',
        paymentPlans: '支付计划',
        clientData: '客户数据',
        account: '账户配置',
        groups: '群组',
        terms: '条款',
        webapp: 'Webapp',
        webappConfig: '配置',
        webappPersonalize: '个性化',
        whatsappweb: 'WhatsApp 网页版',
        whatsappwebConfig: '配置',
        whatsappwebPersonalize: '个性化',
        integrations: '集成',
        integrationPayment: '支付方式',
        integrationPdv: 'POS',
        integrationMessaging: '消息',
        integrationOthers: '其他',
        button: '复制 Pluginspace',
      },

      payment: {
        methods: '支付方式',
        method: '支付形式',
        gateway: '支付网关',
        card: '信用卡',
        debit: '借记卡',
        food: '食物券',
        pix: 'Pix',
        others: '其他',
        pay_money: '现金',
        config: '配置',
        add: '配置支付方式',
        back: '返回支付网关',
        basic_settings: '基本配置',
        modalities: '将使用此支付方式的方式',
        add_payment: '添加支付方式',
        code_erp: 'ERP 代码',
        installments: '分期付款次数',
        edit_payment: '编辑支付方式',
        delete: '删除支付方式',
        money: '现金支付',
        max_installments: '最大分期付款次数是多少？',
        min_value_installments: '分期付款的最小价值是多少？',
        confirm: '确认删除',
        delete_payment: '您要删除此支付方式吗',
        change: '您要进行此更改吗？',
        inative: '您要停用此支付方式吗？',
        inative_change: '您要激活此支付方式并停用旧的吗？',
        motive: '请说明原因',
        /* 用于折扣 */
        config_descount_payment: '按支付方式的折扣配置',

        able_discount_pix: '启用 Pix 付款折扣',
        able_discount_card: '启用银行卡付款折扣',
        able_discount: '启用付款折扣',

        discount_percentage: '百分比折扣',
        discount_monetary: '货币折扣',
        discount_value: '折扣价值',
      },

      icon: {
        title: '图标',
        subtitle: '此处列出了所有库图标',
      },
      freight: {
        title: '发送方式',
        map: '地图',
        map_text: '订单货到付款选项',
        range: '半径',
        range_text: '订单货到付款选项',
        cep: '邮政编码列表',
        cep_text: '订单货到付款选项',
        config: '配置',
        delivery: '自有配送',
        delivery_text: '有 3 个可定制的配送选项：',
        frenet: 'Frenet',
        frenet_text: '通过各种运输公司和发送方式进行完整的运费管理。',
        frenet_text_2: '要启用此集成，需要有 Frenet 计划。',
        site: '查看官方网站',
        coming_soon: '即将推出...',
      },
      frenet: {
        title: '与 Frenet 集成',
        back: '返回配送方式',
        integration: '集成',
        config: '配置',
        dimensions: '以厘米为单位的基本配送尺寸',
        height: '高度',
        width: '宽度',
        length: '长度',
        value: '产品申报价值',
        use: '使用',
        dont_use: '不使用',
        price: '使用简化报价吗？',
        yes: '是',
        no: '否',
        branchCode: 'Jadlog 投递点',
        no_balance: 'Frenet 中无余额',
        value_balance: '您在 Frenet 中有 @ 余额',
        print_balance: '要打印此订单的运费标签，您需要在 Frenet 账户中充值。',
        click_balance: '点击下方按钮可在另一个标签页中访问 Frenet。',
        open_balance: '打开 Frenet 账户',
        valid_token: 'Token 无效',
        declared_value: '申报价值用于运输公司投保。',
        getToken: '要在 Frenet 中找到 Token，您需要访问访问密钥部分并复制 “TOKEN” 字段的值。',
        weight_frenet: '标准重量 (kg)',
        height_frenet: '标准高度 (cm)',
        width_frenet: '标准宽度 (cm)',
        depth_frenet: '标准深度 (cm)',
        alert_title: '运费计算的参考尺寸',
        alert_warning: '注意！',
        alert_description: '这些尺寸将用于计算没有注册体积的产品运费。',
        alert_wrong_values: '不正确的值可能会导致：',
        alert_overpriced: '运费过高（疏远客户）。',
        alert_additional_costs: '额外费用（如果运输公司稍后调整价值）。',
        alert_recommendation: '建议注册每个产品的实际体积。',
        alert_reference: '参考尺寸：',
        alert_small_products: '小件产品',
        alert_small_examples: '(例如: 配件、小饰品、电缆)',
        alert_small_weight: '重量: 0.1–0.3 kg',
        alert_small_dimensions: '尺寸: 10 × 10 × 5 cm',
        alert_medium_products: '中等产品',
        alert_medium_examples: '(例如: 衣服、书籍、小型电子产品)',
        alert_medium_weight: '重量: 0.5–2 kg',
        alert_medium_dimensions: '尺寸: 25 × 20 × 10 cm',
        alert_large_products: '大件产品',
        alert_large_examples: '(例如: 家用电器、大箱子)',
        alert_large_weight: '重量: 5–20 kg 或更多',
        alert_large_dimensions: '尺寸: 50 × 40 × 30 cm 或更大',
      },
      chat: {
        you: '您',
        now: '现在发送',
        send: '发送',
        type_message: '发送消息...',
        initial_message: '欢迎使用 Ninegrid AI 聊天',
        error_message: '我找不到您消息的答案，请更具体或稍后再试。',
        tip_language: '请用中文回答。',
        title_config: '人工智能配置',
        config: '配置人工智能',
        fit: '人工智能训练',
        fit_header: '此处列出了问题及其各自创建的答案',
        add_question: '添加问题',
        edit_question: '编辑问题',
        delete_question: '您要删除以下问题吗？',
        question: '问题',
        answer: '答案',
        date: '日期',
        actions: '操作',
        active: '活动',
        delete: '删除',
        sync: '同步人工智能',
        upload: '文件上传',
        about: '关于',
        chatia: '聊天',
        about_title: '关于 Ninegrid AI',
        about_description_title: '描述',
        about_description: 'Ninegrid AI 是一款智能虚拟助手，旨在帮助您完成支持任务。',
        about_support_title: '支持',
        about_support_description: '如果您有任何疑问或需要帮助，我们的支持团队随时准备提供帮助。',
        about_support_contact_1: '要联系支持人员，请发送电子邮件至',
        about_support_contact_2: '或在我们的门户网站上开票：',
        about_features_title: '功能',
        tips: '创建问题的提示',
        about_tips_1: '使用清晰、客观的问题以获得更好的答案。',
        about_tips_2: '避免使用俚语或复杂的技术术语。',
        about_tips_3: '如果答案不令人满意，请尝试重新组织问题。',
        about_tips_4: 'Ninegrid AI 通过互动学习，因此您使用得越多，它就会变得越好。',
        feature_1: '自然语言对话',
        feature_2: '语音命令支持',
        feature_3: '答案语音合成',
        feature_4: '直观且响应迅速的界面',
        about_manuals: '手册',
        about_manuals_description: '查看我们的手册，了解有关如何使用 Ninegrid 环境的更多信息，',
        about_faq: '常见问题',
        about_faq_description: '查看最常见的问题及其答案，以澄清常见疑问，',
        about_version_title: '系统信息',
        version: '版本',
        last_update: '最近更新',
        rights_reserved: '保留所有权利',
        access_here: '在此访问',
        our_faq: '查看常见问题',
        or: '或',
        and: '和',
      },
      sumary_access: {
        cart: '购物车',
        seller: '销售人员登录',
        category: '类别',
        pdv: '产品详情',
        subcategory: '子类别',
        product: '产品列表',
        home: '起始屏幕',
        'search-order': '订单',
        'store-info': '商店信息',
        customer: '客户注册',
        receipt: '付款收据',
        order: '付款',
        card: '银行卡支付',
        'order-qrcode': '客户 Pix 付款',
        'success-order': '购买成功',
        'filter/pdv': '筛选结果',
        filter: '筛选选择',
        'seller-qrcode': '付款链接',
        'vendor-order ': '销售购物车查询',
        'finalize-order': '购买摘要',
      },
      optional: {
        optionals: '附加项目',
        list: '附加项目列表',
        name: '名称',
        used: '用于',
        config: '配置',
        link: '关联产品',
        products_optional: '与列表关联的产品',
        edit: '编辑附加项目列表',
        type: '选择类型',
        max: '最大值',
        mandatory: '强制性',
        order: '顺序',
        code: '代码',
        qtd: '最大数量',
        price: '价格',
        include: '包含一个附加项目',
        create: '创建附加项目列表',
        description: 'Webapp 描述',
        emptyProduct: '没有产品正在使用此附加项目',
      },

      coupons: {
        title: '优惠券',
        report: '优惠券报告',
        titleCreate: '创建优惠券',
        titleUpdate: '编辑优惠券',
        subTitle: '此处列出了优惠券及其各自的操作。',
        create: '创建优惠券',
        edit: '编辑优惠券',
        delete: '删除优惠券',

        //输入变量
        name: '优惠券名称',
        name_helper: '最多 15 个字符',
        description: '描述',
        description_placeholder: '最多接受 200 个字符',
        seller: '销售人员',
        catalog: '目录',
        discountValue: '折扣价值',
        discountPercentage: '折扣百分比',
        type: '类型',
        dateInit: '开始日期',
        dateEnd: '结束日期',
        quantitative: '使用次数',
      },

      order_print: {
        title: '在确认打印之前检查订单信息',
        print_text: '打印',
        information: 'QZ Tray 将请求建立连接的权限。点击“允许”继续打印。',
        order_details: '订单详情',
        client: '客户',
        payment: '付款',
        created: '已创建',
        print: '打印订单',
        print_confirm: '您要打印此订单吗？请确保打印机已连接并正确配置，然后再继续',
      },

      whatsappweb: {
        title: 'WhatsApp 网页版',
        subtitle: '此处列出了 WhatsApp 配置及其各自的操作。',
        titleCreate: '同步 WhatsApp',
        titleDelete: '移除 WhatsApp 同步',
        create: '同步 WhatsApp',
        delete: '删除 WhatsApp 会话',
        active: '活动',
        welcome: 'Ninegrid WhatsApp 网页版',
        describe_whatsappweb: '可以在此处将 WhatsApp 网页版与商店的手机关联！',
        config: '配置 WhatsApp',
        step1: '在您的手机上打开 WhatsApp。',
        step2: '在 Android 上点击“更多选项”⋮ 或在 iPhone 上点击“设置”⚙️。',
        step3: '点击“已关联设备”，然后点击“关联设备”。',
        step4: '将您的手机对准此屏幕以扫描二维码。',
      },
      fileManagement: {
        title: '文件管理器',
        subtitle: '此处列出了文件及其各自的操作。',
        create: '创建文件',
        edit: '编辑文件',
        delete: '删除文件',
        download: '下载文件',
        upload: '发送文件',
        file: '文件',
        file_name: '文件名称',
        file_item: '项目',
        file_itens: '项目',
        file_type: '文件类型',
        file_size: '文件大小',
        file_date: '创建日期',
        file_actions: '操作',
        file_folder: '文件夹',
        file_new_folder: '新文件夹',
        file_folder_name: '文件夹名称',
        file_last_modified: '最近修改',
        file_description: '文件描述',
        file_description_placeholder: '文件描述',
        file_description_helper: '最多 200 个字符',
        file_name_placeholder: '文件名称',
        file_name_helper: '最多 15 个字符',
        file_page_showing: '显示',
        file_not_found: '未找到任何文件',
        file_uploading: '正在加载文件',
        file_upload: '加载文件',
        file_changing: '正在更改文件',
        file_Loading: '正在加载文件',
        file_update: '更新',
        file_sync_knowledge_base: '同步知识库',
        file_history_sync: '同步历史记录',
        scanned: '已扫描',
        indexed: '已索引',
        modified: '已修改',
        completed: '已完成',
        deleted: '已删除',
        failed: '失败',
        available: '可用',
        last_update: '最近更新',
        status: '状态',
        status_job: '任务状态',
        data_source: '数据源',
        knowledge_base: '知识库',
        history_sync: '同步历史记录',
        chart_scanned_doc: '已扫描文档',
        chart_indexed_doc: '已索引文档',
        chart_modified_doc: '已修改文档',
        chart_deleted_doc: '已删除文档',
        chart_failed_doc: '失败的文档',
        chart_docs_processed: '已处理文档',
        chart_docs_total: '文档总数',
        total_jobs_processed: '已处理任务总数',
        jobs_info: '任务信息',
        observation_table_jobs_phase: '已处理任务表显示每个数据源最近 5 个任务。',
      },
      service_requests: {
        title: '服务表格',
        subtitle: '管理服务请求表格',
        create: '创建服务表格',
        edit: '编辑服务表格',
        delete: '删除服务表格',
        create_form: '创建表格',
        edit_form: '编辑表格',
        delete_form: '删除表格',
        form_title: '标题',
        form_icon: '图标',
        form_status: '状态',
        form_description: '描述',
        form_components: '组件',
        form_grids: '网格',
        priority_label: '优先级',
        priority_low: '低',
        priority_normal: '正常',
        priority_high: '高',
        priority_critical: '紧急',
        choose_icon: '选择',
        add_component: '添加',
        sections: '部分',
        empty_message: '点击“添加”插入组件，拖动以重新排序。',
        success_created: '服务表格创建成功。',
        success_updated: '服务表格更新成功。',
        success_deleted: '服务表格删除成功。',
        error_create: '创建服务表格时出错。',
        error_update: '更新服务表格时出错。',
        error_delete: '删除服务表格时出错。',
        error_load: '加载时出错！',
        validation_title: '请提供会话标题',
        validation_icon: '请为会话选择一个图标',
        validation_components: '保存前至少添加一个组件',
        placeholder_title: '例如: 清洁',
        icon_selected: '已选图标 (SVG)',
        icon_none: '未选择图标',
        visual_instructions: '可视化构建会话。拖动以重新排序。字段仅为视觉效果（不可交互）。',
        component: '组件',
        components_plural: '组件',
        grid: '网格',
        grids_plural: '网格',
        grid_services: '服务网格',
        grid_services_title: '选择服务网格',
        grid_services_search: '搜索网格',
        grid_services_label: '网格',
        grid_services_selected: '已选网格',
        grid_services_error: '搜索酒店网格时出错',
        add_component_modal: '添加组件',
        validation_grids_required: '网格是必填项',
        validation_grids_text: '所有选择组件必须至少选择一个服务网格。',
        actions: '操作',
        breadcrumb_dashboard: '仪表盘',
        breadcrumb_essential_services: '基本服务',
        // UI 元素
        drag_title: '拖动',
        drag_action: '拖动',
        remove_title: '移除',
        remove_aria_label: '移除块',
        max_quantity_title: '最大数量：',
        max_prefix: '最大值:',
        description_label: '描述',
        sections_label: '部分',
        // 模态框标题和操作
        select_icon_title: '选择',
        no_icons_available: '没有可用的图标…',
        search_placeholder: '输入以搜索...',
        grid_services_selected_label: '已选择：',
        no_grid_found: '未找到任何网格',
        no_grid_available: '没有可用的网格',
        grid_status_active: '活动',
        grid_status_inactive: '非活动',
        cancel_button: '取消',
        save_button: '保存',
        confirm_button: '确认',
        // 数量模态框
        max_quantity_modal_title: '定义最大数量',
        max_quantity_label: '最大数量',
        max_quantity_placeholder: '输入最大数量',
        max_quantity_helper: '定义此字段中可选择的最大项目数。',
        // 面包屑
        breadcrumb_create: '创建',
        breadcrumb_edit: '编辑',
        // 表单组件
        sample_service_1: '服务 1',
        sample_service_2: '服务 2',
        sample_hygiene: '卫生',
        sample_drinks: '饮料',
        room_number_label: '客房号码',
        select_placeholder: '选择...',
        date_label: '日期',
        hour_label: '小时',
        quantity_label: '数量',
        between_placeholder: '介于',
        and_placeholder: '和',
        select_list_label: '选择（列表）',
        select_item_placeholder: '选择一个项目',
        select_checkbox_label: '选择（复选框）',
        // Visibility
        visible_to_label: '可见对象',
        visible_to_employees: '员工',
        visible_to_customers: '客户',
        visible_to_both: '两者',
        select_category_placeholder: '选择一个类别',
        select_quantity_label: '选择（数量）',
        qty_label: '数量',
        // 目录标题
        catalog_room_number: '客房号码',
        catalog_date: '日期',
        catalog_hour: '小时',
        catalog_date_hour: '日期 + 小时',
        catalog_select_list: '选择（列表）',
        catalog_select_list_quantity: '选择（列表）+ 数量',
        catalog_select_checkbox: '选择（复选框）',
        catalog_select_count: '选择（数量）',
        catalog_quantity: '数量',
      },
      base_modal: {
        attention_title: '注意！',
        unsaved_changes_text: '所做的更改将丢失，您确定要离开吗？',
        confirm_button: '是',
        cancel_button: '否',
      },
      summarize_ia: {
        title: '人工智能使用摘要',
        subtitle: '此处列出了人工智能摘要信息。',
        create: '创建人工智能摘要',
        edit: '编辑人工智能摘要',
        delete: '删除人工智能摘要',
        summarize: '摘要',
      },
      hospitality: {
        add_room: '添加客房',
        create_multiples: '创建多个',
        add_activity: '添加活动',
        add_experience: '添加体验',
        experiences: '体验',
        experience_type: '体验类型',
        experience_duration: '持续时间',
        experience_price: '价格',
        experience_rating: '评分',
        experience_includes: '包含',
        create_experience: '创建体验',
        edit_experience: '编辑体验',
        experience_created: '体验创建成功！',
        experience_updated: '体验更新成功！',
        experience_deleted: '体验删除成功！',
      },
      hospitality_content: {
        page_title: '按钮',
        page_subtitle: '此处列出了各部分的按钮。',
        add_button: '添加按钮',
        filters: {
          sections: '部分',
        },
        table: {
          headers: {
            title: '标题',
            order: '顺序',
            formTitle: '表单标题',
            type: '类型',
            actions: '操作',
          },
        },
        actions: {
          edit: '编辑按钮',
          delete: '删除按钮',
          delete_confirm: '您确定要删除此按钮吗？',
        },
        type_labels: {
          service_form: '服务表单',
          feedback: '您的意见',
          service: '服务',
          information: '信息',
          activities_leisure: '活动与休闲',
          bars_restaurants: '酒吧与餐厅',
          schedule: '预订',
          experience: '体验',
          booking: '日程安排',
          check_in: '入住',
          check_out: '退房',
          tours: '观光',
          page_dynamic: '动态页面',
        },
        no_category: '无类别',
        messages: {
          filter_error_title: '错误',
          filter_error_text: '过滤部分时出错',
          load_error_title: '加载错误',
          load_error_text: '加载部分失败！',
          section_not_found_title: '错误',
          section_not_found_text: '未找到部分！',
          deleted_title: '部分已删除',
          deleted_text: '删除成功！',
          delete_error: '删除部分时出错！',
          form: '表单',
          page: '页面',
        },
        create_modal: {
          modal_title: '添加内容',
          alert_title: '部分和内容选择',
          alert_subtitle: '请选择对应的部分和内容。',
          label_section: '部分',
          label_content: '内容',
          placeholder_select: '请选择',
          placeholder_select_section: '选择部分',
          placeholder_select_content: '选择内容',
          order_label: '顺序',
          selection_summary: '选择摘要:',
          badge_section: '部分',
          badge_content: '内容',
          select_form_label: '选择表单 (roomService)',
          tips_title: '提示',
          tips: {
            item1: '一个部分可以有多个内容',
            item2: '一个内容可以属于多个部分',
            item3: '顺序定义了列表中项目的位置',
          },
          buttons: {
            cancel: '取消',
            create: '创建',
          },
          swal: {
            missing_field_title: '缺少字段',
            missing_section: '请选择一个部分以继续',
            missing_content: '请选择一个内容以继续',
            invalid_field_title: '无效字段',
            invalid_order: '顺序必须是正数或零',
            created_title: '内容已注册',
            created_text: '注册成功！',
            create_error: '注册内容时出错！',
          },
        },
        edit_modal: {
          modal_title: '编辑内容',
          alert_title: '内容编辑',
          alert_subtitle: '根据需要更改部分和顺序。当前内容无法更改。',
          label_section: '部分',
          label_content: '内容',
          placeholder_select: '请选择',
          placeholder_select_section: '选择部分',
          placeholder_select_content: '选择内容',
          order_label: '顺序',
          selection_summary: '选择摘要:',
          badge_section: '部分',
          badge_content: '内容',
          tips_title: '提示',
          tips: {
            item1: '您只能更改部分',
            item2: '顺序定义了列表中项目的位置',
          },
          buttons: {
            cancel: '取消',
            save: '保存',
          },
          swal: {
            missing_field_title: '缺少字段',
            missing_section: '请选择一个部分以继续',
            missing_content: '请选择一个内容以继续',
            invalid_field_title: '无效字段',
            invalid_order: '顺序必须是正数或零',
            updated_title: '内容已更新',
            updated_text: '更新成功！',
            update_error: '更新内容时出错！',
          },
        },
        category: {
          page_title: '部分',
          page_subtitle: '此处列出了内容部分及其各自的操作。',
          add_button: '添加',
          breadcrumbs: {
            dashboard: '仪表板',
            categories: '类别',
          },
          table: {
            headers: {
              section: '部分',
              order: '顺序',
              status: '状态',
              actions: '操作',
            },
          },
          options: {
            edit_category: '编辑类别',
            delete_section: '删除部分',
            delete_confirm: '删除部分',
          },
          swal: {
            deleted_title: '部分已删除',
            deleted_text: '删除成功！',
            delete_error: '删除部分时出错！',
          },
          create: {
            missing_fields_title: '缺少字段',
            missing_fields_text: '请检查是否已正确填写所有字段！',
            created_title: '类别已注册',
            created_text: '注册成功！',
            create_error: '注册类别时出错！',
          },
          update: {
            missing_fields_title: '缺少字段',
            missing_fields_text: '请检查是否已正确填写所有字段！',
            updated_title: '类别已更新',
            updated_text: '编辑成功！',
            update_error: '更新类别时出错！',
          },
          type: {
            default: '默认',
            banner: '特色横幅',
          },
        },
      },
      clean_safe: {
        title: '清洁与安全',
        subtitle: '管理安全措施、清洁协议和认证',
        security_measures: '安全措施',
        cleaning_protocols: '清洁协议',
        certifications: '认证',
        add_security_measure: '添加措施',
        add_cleaning_protocol: '添加协议',
        add_certification: '添加认证',
        add_new_security_measure: '添加新措施',
        add_new_cleaning_protocol: '添加新协议',
        add_new_certification: '添加新认证',
        security_measure: '安全措施',
        cleaning_protocol: '清洁协议',
        certification: '认证',
        icon: '图标',
        choose_icon: '选择图标',
        title_field: '标题',
        description: '描述',
        status: '状态',
        active: '活动',
        inactive: '非活动',
        remove: '移除',
        save: '保存',
        required_title: '标题是必填项',
        required_icon: '图标是必填项',
        required_fields: '必填字段',
        required_fields_message: '请填写所有必填字段。',
        confirmation: '确认',
        delete_security_measure_confirm: '您确定要删除此安全措施吗？',
        delete_cleaning_protocol_confirm: '您确定要删除此清洁协议吗？',
        delete_certification_confirm: '您确定要删除此认证吗？',
        yes: '是',
        no: '否',
        error: '错误',
        error_delete: '删除项目时出错。',
        success: '成功',
        success_save: '卫生和安全数据保存成功！',
        error_save: '保存数据时出错。',
        empty_security_measures: '尚未添加任何安全措施。',
        empty_cleaning_protocols: '尚未添加任何清洁协议。',
        empty_certifications: '尚未添加任何认证。',
        empty_start_message: '点击“添加”开始。',
        placeholder_security_title: '输入安全措施标题',
        placeholder_protocol_title: '输入协议标题',
        placeholder_certification_title: '输入认证标题',
        placeholder_security_description: '输入简短描述（最多 100 个字符）',
        placeholder_protocol_description: '输入清洁协议的详细描述',
      },
      orders_room_service: {
        title: '客房订单',
        subtitle: '酒店服务请求管理',

        // 筛选
        status: '状态',
        start_date: '开始日期',
        end_date: '结束日期',
        reservation_id: '预订代码',
        post_id: '帖子 ID',
        service_type: '服务类型',
        search: '搜索',
        clear_filters: '清除筛选',

        // 状态
        status_pending: '待定',
        status_confirmed: '已确认',
        status_in_progress: '进行中',
        status_cancelled: '已取消',
        status_concluded: '已完成',
        status_completed: '已完成',

        // 筛选选项
        all_status: '所有状态',
        all_types: '所有类型',
        service_forms: '服务表格',
        services: '服务',

        // 表格标题
        service: '服务',
        room: '客房',
        price: '价格',
        people_qty: '人数',
        reservation: '预订',
        date: '日期',
        time: '时间',
        priority: '优先级',
        created_at: '创建于',
        actions: '操作',

        // 操作工具提示
        view_details: '查看详情',
        change_status: '更改状态',

        // 详情模态框
        order_details: '订单详情',
        close: '关闭',
        loading_details: '正在加载订单详情...',
        loading: '正在加载...',

        // 订单信息
        order: '订单',
        room_service: '客房服务',
        location: '地点',
        room_number: '客房号码',
        scheduled_date: '预定日期',
        no_time: '无时间',
        reservation_id_label: '预订代码',

        // 客户信息
        customer_info: '客户信息',
        full_name: '全名',
        email: '电子邮件',
        phone: '电话',

        // 请求详情
        request_summary: '请求摘要',
        service_details: '服务详情',
        request_details: '请求详情',
        no_items_selected: '未选择任何项目',
        not_informed: '未提供',
        units: '单位',

        // 技术信息
        technical_info: '技术信息',
        post: '帖子',
        booking_type: '预订类型',
        hotel_info: '酒店信息',
        hotel_name: '酒店名称',
        subdomain: '子域名',
        type: '类型',
        service_form: '服务表格',
        last_update: '最近更新',
        additional_notes: '附加备注',

        // 更改状态模态框
        change_status_title: '更改状态',
        current_status: '当前状态',
        new_status: '新状态',
        select_status: '选择状态',

        // 占位符
        select_status_placeholder: '选择状态',
        select_service_type_placeholder: '选择服务类型',
        start_date_placeholder: '开始日期',
        end_date_placeholder: '结束日期',
        reservation_id_placeholder: '输入预订 ID',
        post_id_placeholder: '输入帖子 ID',
        new_status_placeholder: '选择新状态',

        // 错误和成功消息
        error: '错误',
        success: '成功',
        warning: '注意',
        error_loading_orders: '加载订单时出错！',
        error_loading_details: '加载订单详情时出错！',
        error_changing_status: '更改订单状态时出错！',
        success_status_changed: '状态更改成功！',
        select_status_warning: '请选择一个状态。',

        // 客户评价
        customer_review: '客户评价',
        rating: '评分',
        review_comment: '评论',
      },
      s3Analytics: {
        title: 'S3 分析',
        startDate: '开始日期',
        endDate: '结束日期',
        pluginspaceId: 'Pluginspace ID',
        pluginspaceIdPlaceholder: '输入 Pluginspace ID',
        method: '方法',
        methodPlaceholder: '输入方法 (GET, POST, etc.)',
        loadData: '加载数据',
        generateAIAnalysis: '生成人工智能分析',
        chatWithAI: '与人工智能聊天',
        showRanking: '显示排名',
        analyzeWithAI: '用人工智能分析',
        close: '关闭',
        totalRequests: '请求总数',
        totalCost: '总成本',
        averageCostPerRequest: '每次请求的平均成本',
        consumptionByPluginspace: '按 Pluginspace 消耗',
        consumptionByMethod: '按方法消耗',
        consumptionByDate: '按日期消耗',
        costAnalysis: '成本分析',
        aiAnalysis: '人工智能分析',
        chatMessage: '输入您关于数据的问题...',
        speakAnalysis: '收听分析',
        filterData: '筛选数据',
        noDataFound: '所选筛选器未找到任何数据',
        errorLoadingData: '加载数据时出错',
        errorGeneratingAnalysis: '生成人工智能分析时出错',
        analysisGenerated: '分析生成成功！',
        dataLoaded: '数据加载成功！',
        rankingData: '排名数据',
        aiChatResponse: '人工智能回复',
        s3Analytics: 'S3 分析',
        filters: '筛选',
        totalConsumption: '总消耗',
        totalRecords: '总记录数',
        error: '错误',
        fetchError: '获取 S3 数据时出错',
        aiAnalysisError: '生成人工智能分析时出错',
        aiChatError: '与人工智能聊天时出错',
        askQuestion: '输入您关于数据的问题...',
        ask: '询问',
        cancel: '取消',
        ok: '确定',
        aiResponse: '人工智能回复',
        aiAnalysisTitle: '人工智能分析',
        account: '账户',
        pluginspace: '商店',
        uniquePluginspaces: '唯一商店',
        methodDistribution: '按方法分布',
        timeAnalysis: '时间分析',
        dataTable: '数据表',
        showingFirst10: '显示前 10 个',
        of: '的',
        records: '记录',
        consumption: '消耗',
        cost: '成本',
        date: '日期',
        allMethods: '所有方法',
        exportData: '导出数据',
      },
      hospitality_store: {
        establishment: '场所',
        select_establishment: '选择...',
        link: '链接',
        status: '状态',
        payment_integrated: '集成支付',
        order: '顺序',
        store_image: '商店图片',
        store_image_hint: '选择代表商店的图片',
        description: '描述',
        cnpj: 'CNPJ',
        code: '代码',
        store_id_placeholder: '商店 ID',
        type: '类型',
        store_type_placeholder: '场所类型',
        no_store_found: '未找到任何场所。',
        edit_store: '编辑场所',
        edit_store_subtitle: '编辑场所数据。',
      },
      stores_pages: {
        title: '场所',
        subtitle: '此处列出了酒店场所及其各自的操作。',
        create: '创建场所',
        no_results: '未找到任何场所。',
        table: {
          code: '代码',
          image: '图片',
          name: '商店',
          cnpj: 'CNPJ',
          vinculation: '关联',
          vinculation_default: '默认',
          vinculation_dynamic: '动态',
          type: '类型',
          order: '顺序',
          status: '状态',
          status_active: '活动',
          status_inactive: '非活动',
          payment_integrated: '集成支付',
          actions: '操作',
        },
        actions: {
          edit: '编辑场所',
          delete_confirm: '您确定要删除吗？',
          delete: '删除场所',
        },
        delete_success: '场所删除成功。',
        delete_error: '删除场所时出错。请重试。',
        success: '成功！',
        error: '错误！',
      },
      stores_pages_create: {
        title: '创建场所',
        subtitle: '为酒店创建新场所。',
        form: {
          establishment: '场所',
          select_placeholder: '选择...',
          link: '链接',
          link_placeholder: 'https://webapp.ninegrid.com.br/...',
          status: '状态',
          status_options: {active: '活动', inactive: '非活动'},
          payment_integrated: '集成支付',
          payment_options: {active: '活动', inactive: '非活动'},
          order: '顺序',
          image_label: '场所图片',
          image_smalltext: '选择代表场所的图片',
          description: '描述',
          info_title: '场所信息',
          cnpj: 'CNPJ',
          code: '代码',
          type: '类型',
          vinculation_label: '关联类型',
          vinculation_options: {default: '默认', dynamic: '动态'},
          empty_message: '未找到任何场所。',
        },
        placeholders: {
          order: '0',
          cnpj: '00.000.000/0000-00',
          store_id: '商店 ID',
        },
        console_messages: {
          image_upload_error: '图片上传错误',
        },
        messages: {
          warning_title: '注意',
          select_store_warning: '保存前请选择一个有效的场所。',
          error_saving: '保存场所时出错。请重试。',
          success_saved: '场所保存成功。',
        },
      },
      feedback_reviews: {
        title: '搜索和满意度评价',
        subtitle: '查看和管理来自反馈表单的所有评分和回复',
        breadcrumb_feedback: '满意度反馈',
        error: '错误',
        success: '成功',
        loading: '加载中...',
        loading_details: '正在加载评论详情...',
        close: '关闭',
        error_loading_reviews: '加载评论时出错',
        error_loading_details: '加载评论详情时出错',
        error_changing_status: '更改评论状态时出错',
        success_status_changed: '状态更改成功',
        confirm_status_change: '确认更改状态',
        confirm_status_change_text: '您确定要更改此评论的状态吗？',

        // 状态
        status_pending: '待定',
        status_approved: '已批准',
        status_rejected: '已拒绝',

        anonymous_active: '启用',
        anonymous_inactive: '禁用',

        // 筛选器
        filters: {
          feedback_form: '表单',
          status: '状态',
          anonymous: '匿名',
          select_anonymous_placeholder: '全部',
          rating: '评分',
          reservation_id: '预订ID',
          start_date: '开始日期',
          end_date: '结束日期',
          date: '日期',
          all_forms: '所有表单',
          all_status: '所有状态',
          all_ratings: '所有评分',
          select_form_placeholder: '选择一个表单',
          select_status_placeholder: '选择一个状态',
          select_rating_placeholder: '选择一个评分',
          reservation_id_placeholder: '输入预订ID',
          start_date_placeholder: '选择开始日期',
          end_date_placeholder: '选择结束日期',
          filter_button: '筛选',
          clear_filters: '清除筛选器',
        },

        // 表格
        table: {
          feedback_form: '表单',
          customer: '客户',
          room: '房间',
          reservation: '预订',
          rating: '评分',
          status: '状态',
          date: '日期',
          time: '时间',
          actions: '操作',
        },

        // 操作
        actions: {
          view_details: '查看详情',
          approve: '批准',
          reject: '拒绝',
        },

        // 评论详情
        review_details: '评论详情',
        room: '房间',
        reservation: '预订',
        feedback_form: '表单',
        responses: '回复',
        technical_info: '技术信息',
        created_at: '创建于',
        updated_at: '更新于',
        review_id: '评论ID',
        plugin_space_id: '插件空间ID',
        anonymous_response: '匿名回复',
        no_reservation_linked: '此回复未链接到特定的预订',
        no_detailed_responses: '此评论没有详细回复',
        // New keys added for feedback_reviews
        anonymous_label: '匿名',
        email_anonymous: '匿名电子邮件',
        email_not_informed: '未提供电子邮件',
        response_title: '回复',
        no_rating_provided: '未提供评分',
        no_items_selected: '未选择任何项目',
        no_option_selected: '未选择任何选项',
        no_answer_provided: '未提供回答',
        form_label: '表单',
        client_not_identified: '无法识别客户',
        types: {
          title: '标题',
          text: '文本',
          textarea: '多行文本',
          stars: '评分（星级）',
          checkbox: '复选框',
          radio: '单选',
          select: '下拉选择',
          number: '数字',
          date: '日期',
          time: '时间',
          image: '图片',
          link: '链接',
        },
      },
      stores_pages_edit: {
        title: '编辑场所',
        subtitle: '编辑场所数据。',
        form: {
          establishment: '场所',
          select_placeholder: '选择...',
          link: '链接',
          link_placeholder: 'https://webapp.ninegrid.com.br/...',
          status: '状态',
          status_options: {active: '活动', inactive: '非活动'},
          payment_integrated: '集成支付',
          payment_options: {active: '活动', inactive: '非活动'},
          order: '顺序',
          image_label: '场所图片',
          image_smalltext: '选择代表场所的图片',
          description: '描述',
          info_title: '场所信息',
          cnpj: 'CNPJ',
          code: '代码',
          type: '类型',
          vinculation_label: '关联类型',
          vinculation_options: {default: '默认', dynamic: '动态'},
          empty_message: '未找到任何场所。',
        },
        placeholders: {
          order: '0',
          cnpj: '00.000.000/0000-00',
          store_id: '商店 ID',
        },
        console_messages: {
          image_upload_error: '图片上传错误',
          image_remove_error: '保存时移除图片出错',
        },
        messages: {
          success_updated: '场所更新成功。',
          error_updating: '更新场所时出错。请重试。',
          payment_change_warning_title: '注意',
          payment_change_warning_text: '此更改可能会在退房时更改正在进行中的预订价值。',
          payment_confirm: '是，继续',
          cancel: '取消',
        },
      },
      hospitality_section: {
        index: {
          page_title: '发布页面',
          page_subtitle: '这里列出了内容发布页面及其相应的操作。',
          add_button: '添加发布页面',
          filters: {
            sections: '发布页面',
          },
          table: {
            headers: {
              title: '标题',
              order: '顺序',
              formTitle: '表单标题',
              type: '类型',
              actions: '操作',
            },
          },
          actions: {
            edit: '编辑发布页面',
            delete: '删除发布页面',
          },
        },
        create: {
          page_title: '创建发布页面',
          page_subtitle: '为酒店创建新的内容发布页面。',
          add_button: '添加发布页面',
          filters: {
            sections: '板块',
          },
        },
        edit: {
          page_title: '编辑发布页面',
          page_subtitle: '编辑内容发布页面数据。',
        },
        // 板块的动态翻译
        types: {
          category: '分类',
          content: '内容',
          simple: '简单',
          form: '表单',
          page: '商店或餐廳頁面',
        },
        status: {
          active: '活跃',
          inactive: '非活跃',
        },
        actions: {
          create: '创建',
          edit: '编辑',
          delete: '删除',
          save: '保存',
          cancel: '取消',
          update: '更新',
          remove_icon: '移除图标',
          select_icon: '选择图标',
        },
        fields: {
          title: '发布页面标题',
          type: '发布页面类型',
          category: '分类',
          order: '顺序',
          status: '状态',
          icon: '图标',
          icon_selected: '选定的图标',
          icon_not_selected: '未选择图标',
          icon_description: '从发布页面的侧边列表中选择图标',
          icon_change_description: '从侧边列表中选择其他图标或删除当前图标',
        },
        placeholders: {
          title: '输入发布页面标题',
          type: '选择类型',
          category: '选择分类',
          order: '0',
          search_icon: '搜索图标...',
          all_categories: '所有分类',
        },
        messages: {
          validation: {
            title_required: '标题是必需的！',
            category_required: '请选择分类！',
            icon_required: '请选择图标！',
          },
          success: {
            created: '发布页面创建成功！',
            updated: '发布页面更新成功！',
            deleted: '发布页面删除成功！',
          },
          error: {
            create: '创建发布页面失败！',
            update: '更新发布页面失败！',
            delete: '删除发布页面失败！',
            load: '加载发布页面数据失败！',
          },
          confirm: {
            delete_title: '确定吗？',
            delete_text: '此操作无法撤消！',
            delete_confirm: '是的，删除',
            delete_cancel: '取消',
          },
          delete: {
            deleted_title: '发布页面已删除',
            deleted_text: '删除成功！',
            error_title: '删除发布页面时出错！',
            error_text: '删除发布页面时发生错误。请重试。',
          },
        },
      },
      hospitality_classification_post: {
        index: {
          page_title: '发布分类',
          page_subtitle: '这里列出了发布分类及其相应的操作。',
          add_button: '添加发布分类',
          filter_all: '所有分类',
          table: {
            headers: {
              title: '标题',
              image: '图片',
              summary: '摘要',
              status: '状态',
              classification: '分类',
              actions: '操作',
            },
            actions: {
              edit: '编辑发布分类',
              delete: '删除发布分类',
            },
          },
        },
        create: {
          page_title: '创建发布分类',
          page_subtitle: '为酒店创建新的发布分类。',
          add_button: '添加发布分类',
          success: {
            created_title: '发布分类已创建',
            created_text: '注册成功完成！',
          },
          error: {
            created_title: '创建发布分类错误！',
            created_text: '创建分类时发生错误。请重试。',
          },
        },
        edit: {
          page_title: '编辑发布分类',
          page_subtitle: '编辑发布分类数据。',
          error: {
            created_title: '编辑发布分类错误！',
            created_text: '编辑分类时发生错误。请重试。',
          },
          success: {
            created_title: '发布分类已编辑',
            created_text: '注册成功完成！',
          },
        },
      },
      hospitality_post: {
        index: {
          page_title: '发布内容',
          page_subtitle: '这里列出了酒店发布内容及其相应的操作。',
          add_button: '添加发布内容',
          filter_all: '全部',
          filter: '分类',
          table: {
            headers: {
              title: '标题',
              image: '图片',
              summary: '摘要',
              status: '状态',
              classification: '分类',
              actions: '操作',
            },
            actions: {
              edit: '编辑发布内容',
              delete: '删除发布内容',
            },
          },
        },
        create: {
          page_title: '创建发布内容',
          page_subtitle: '为酒店创建新的发布内容。',
          success: {
            created_title: '发布内容已创建',
            created_text: '注册成功完成！',
          },
          error: {
            created_title: '创建发布内容错误！',
            created_text: '创建发布内容时发生错误。请重试。',
          },
        },
        edit: {
          page_title: '编辑发布内容',
          page_subtitle: '编辑发布内容数据。',
          success: {
            created_title: '发布内容已编辑',
            created_text: '注册成功完成！',
          },
          error: {
            created_title: '编辑发布内容错误！',
            created_text: '编辑发布内容时发生错误。请重试。',
          },
        },
        form_validate: {
          title_required: '标题是必需的！',
          summary_required: '摘要是必需的！',
          classification_required: '分类是必需的！',
          content_required: '内容是必需的！',
          fields_missing: '请检查是否填写了所有字段！',
        },
      },
      hospitality_post_page: {
        types: {
          simple: '简单',
          section: '栏目',
          form: '表单',
          category: '分类',
        },
        index: {
          page_title: '发布页面',
          page_subtitle: '这里列出了内容发布页面及其各自的操作。',
          add_button: '添加发布页面',
          edit_button: '编辑发布页面',
          delete_button: '删除发布页面',
        },
        create: {
          page_title: '创建发布页面',
          page_subtitle: '为酒店创建新的内容发布页面。',
          form: {
            title: '发布页面标题',
            type: '发布页面类型',
            status: '状态',
          },
          icon: {
            icon: 'SVG图标',
            lib: 'SVG图标库',
            search: '搜索图标...',
            category: '图标分类',
            description: '从发布页面的侧边列表中选择图标',
            selected: '已选择的图标',
            no_selected: '未选择图标',
            selected_description: '从发布页面的侧边列表中选择图标',
            no_selected_description: '未选择图标。请从发布页面的侧边列表中选择图标',
            change_description: '从侧边列表中选择其他图标或删除当前图标',
          },
          success: {
            created_title: '发布页面已创建',
            created_text: '注册已成功完成！',
          },
          error: {
            created_title: '创建发布页面错误！',
            created_text: '创建页面时发生错误。请重试。',
          },
        },
        edit: {
          page_title: '编辑发布页面',
          page_subtitle: '编辑内容发布页面的数据。',
          form: {
            title: '发布页面标题',
            type: '发布页面类型',
            status: '状态',
          },
          icon: {
            icon: 'SVG图标',
            lib: 'SVG图标库',
            search: '搜索图标...',
            category: '图标分类',
            description: '从发布页面的侧边列表中选择图标',
            selected: '已选择的图标',
            no_selected: '未选择图标',
            selected_description: '从发布页面的侧边列表中选择图标',
            no_selected_description: '未选择图标。请从发布页面的侧边列表中选择图标',
            change_description: '从侧边列表中选择其他图标或删除当前图标',
          },
          success: {
            created_title: '发布页面已编辑',
            created_text: '编辑已成功完成！',
          },
          error: {
            created_title: '编辑发布页面错误！',
            created_text: '编辑页面时发生错误。请重试。',
          },
        },
      },
      // Translations for Booking Hotel Services
      booking_hotel_services: {
        // Index page
        page_title: '服务预订',
        page_subtitle: '管理服务预订',
        breadcrumb_services: '预订服务',
        breadcrumb_booking: '预订服务',
        create_button: '创建服务预订',

        // Table headers
        table_image: '图片',
        table_title: '标题',
        table_order: '顺序',
        table_status: '状态',
        table_actions: '操作',

        // Table actions
        action_edit: '编辑',
        action_delete: '删除',

        // Status
        status_active: '活跃',
        status_inactive: '非活跃',

        // Messages
        delete_success: '预订已删除',
        delete_error: '删除预订错误',
        delete_confirm: '确认删除？',

        // Create page
        create_title: '创建服务预订',
        create_subtitle: '填写信息以创建新的服务预订',

        // Edit page
        edit_title: '编辑酒店预订',
        edit_subtitle: '编辑预订信息',

        // Form fields
        field_title_label: '标题',
        field_title_placeholder: '例：水疗预订',
        field_status_label: '状态',
        field_description_label: '描述',
        field_image_label: '图片',
        field_icon_label: '图标',

        // Icon picker
        icon_choose: '选择图标',
        icon_choose_modal: '选择图标',

        // Day configuration
        day_config_title: '日期配置',
        day_configure: '配置',
        day_periods_title: '时间段',
        day_period_add: '添加时间段',
        day_period_max: '最多3个时间段',
        day_period_none: '未配置时间段。请至少添加一个时间段。',
        day_period_overlap: '时间段不能重叠。请调整配置的时间。',
        day_period_label: '时间段',
        day_period_remove: '移除',
        day_interval_label: '间隔（分钟）',
        day_start_time_label: '开始时间',
        day_end_time_label: '结束时间',

        // Day names
        day_sunday: '星期日',
        day_monday: '星期一',
        day_tuesday: '星期二',
        day_wednesday: '星期三',
        day_thursday: '星期四',
        day_friday: '星期五',
        day_saturday: '星期六',

        // Grid selection
        grid_title: '关联网格',
        grid_select: '选择网格',
        grid_selected: '个网格已选择',
        grid_capacity: '容量',
        grid_multiple: '多个',
        grid_multiple_yes: '是',
        grid_multiple_no: '否',
        grid_status_active: '活跃',
        grid_status_inactive: '非活跃',
        grid_item_name_placeholder: '名称（例如：放松按摩）',
        grid_item_value_placeholder: '价格（例如：50.00）',

        // Action buttons
        button_back: '返回',
        button_save: '保存',
        button_update: '更新',
        button_create: '创建',
        button_cancel: '取消',
        button_confirm: '确认',

        // Validation messages
        validation_title_required: '必填字段',
        validation_title_text: '标题是必需的。',
        validation_icon_required: '必填字段',
        validation_icon_text: '选择一个图标。',
        validation_day_required: '需要配置',
        validation_day_text: '至少配置一周中的一天。',

        // Success messages
        success_created: '预订已创建',
        success_created_text: '预订创建成功！',
        success_updated: '预订已更新',
        success_updated_text: '预订更新成功！',

        // Error messages
        error_create: '创建错误',
        error_create_text: '创建预订时发生错误。',
        error_update: '更新错误',
        error_update_text: '更新预订时发生错误。',
        error_save: '错误',
        error_save_text: '保存预订时发生错误。',
        error_load: '错误',
        error_load_text: '加载预订数据错误。',

        // Breadcrumbs
        breadcrumb_dashboard: '仪表板',
        breadcrumb_hospitality: '酒店服务',
        breadcrumb_hotel_reservations: '酒店预订',
        breadcrumb_create: '创建',
        breadcrumb_edit: '编辑',
      },
      users: {
        houserkeeping: '客房服务',
        maintenancetechnician: '维修技术员',
        receptionist: '接待员',
        manager: '经理',
        administrator: '管理员',
        waiter: '服务员',
        kitchenchief: '厨师长',
        warehouse: '仓库管理员',
        concierge: '礼宾部',
        messenger: '信使',
        receptionsupervisor: '前台主管',
        telephonist: '话务员',
        cook: '厨师',
        barman: '调酒师',
        roomserviceattendant: '客房服务员',
        steward: '管事',
        sommelier: '侍酒师',
        plumber: '水管工',
        airconditiontechnician: '空调技术员',
        maintenancesupervisor: '维修主管',
        reservationagent: '预订员',
        reservationcoordinator: '预订协调员',
        salesexecutive: '销售主管',
        revenuemanager: '收益经理',
        commercialmanager: '商务经理',
        administrativeassistant: '行政助理',
        financeaccountspayable: '财务 - 应付账款',
        accountant: '会计',
        humanresources: '人力资源',
        purchasingwarehouse: '采购和仓库',
        recreator: '娱乐员',
        activityinstructor: '活动指导员',
        experiencecoordinator: '体验协调员',
        tourguide: '导游',
        childmonitor: '儿童监护员',
        securityguard: '保安',
        doorman: '门卫',
        accesscontroller: '门禁控制员',
        securitysupervisor: '安保主管',
        generalmanager: '总经理',
        assistantmanager: '副经理',
        operationalmanager: '运营经理',
        departmentsupervisorscoordinators: '部门主管和协调员',
        floormanager: '楼层经理',
        governancesupervisor: '客房主管',
        generalservicesassistant: '通用服务助理',
        laundryattendant: '洗衣房服务员',
        laundrymanager: '布草经理',
        machinist: '机器操作员',
        ironer: '熨烫工',
        electrician: '电工',
        carpenter: '木工',
      },
    },
  },
}

export {messages}
// hospitality_experiences block moved inside translations below
